export const QUESTIONS = [
  {
    "id": 1,
    "question": "One of Murali’s staff members has malware on their PC. They claim that they downloaded only a spreadsheet tool, not malware. Which type of malware have they encountered if the malware was designed to look legitimate but was actually malicious?",
    "choice_a": "A worm",
    "choice_b": "A virus",
    "choice_c": "A Trojan",
    "choice_d": "A rootkit",
    "correct_answer": "C",
    "explanation": "Trojans, or Trojan horses, are malware designed to appear legitimate but that are actually malicious. Viruses require human interaction to spread, whereas worms propagate on their own via networks, often targeting vulnerable services. Rootkits help attackers obtain and maintain persistent access to systems.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.2 and covers material discussed in Chapter 20.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      78,
      69,
      75,
      71,
      73
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 2,
    "question": "In the following image, a connection between two systems has been redirected by an attacker. The attacker has spoofed ARP packets to make it so that responses to the legitimate server are instead sent to a system that the attacker controls. When traffic is sent to that system, the attacker reads and potentially modifies the traffic before passing it along the server, then sends back responses from the server after reviewing or modifying them as well. Which type of attack is this? <img src=\"/question_assets/CC/pt01uf001.webp\" alt=\"\"/>",
    "choice_a": "An ARPjacking",
    "choice_b": "A disassociation attack",
    "choice_c": "A man-in-the-middle (MitM) attack",
    "choice_d": "A TCP redirect attack",
    "correct_answer": "C",
    "explanation": "This is one form of a man-in-the-middle (MitM) attack, also known as an on-path attack, an attack that redirects traffic to a system or device controlled by the attacker, which can then take action on network traffic originally destined for another system. ARPjacking and TCP redirect attacks are made up. Disassociation attacks focus on causing Wi-Fi devices to drop their connections and try to reconnect to an access point.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.2 and covers material discussed in Chapter 20.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      70,
      80,
      92,
      78,
      69
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 3,
    "question": "Which of the following best describes why businesses classify their data and the implications for security controls?",
    "choice_a": "Data classification primarily exists for businesses to categorize their marketing strategies.",
    "choice_b": "Data classification programs are solely used by government agencies to classify national security information and are not utilized by businesses.",
    "choice_c": "Data classification allows organizations to specify the necessary security controls to protect information based on its sensitivity, impacting the measures used to prevent unauthorized access.",
    "choice_d": "Data classification is an outdated system and no longer plays a role in modern data protection efforts.",
    "correct_answer": "C",
    "explanation": "Organizations use data classification to categorize information based on its sensitivity, which directly informs the necessary security controls for protecting that information from unauthorized access. This process allows a systematic approach to protecting the most crucial data and minimizing potential damage from data breaches. Conversely, data classification isn’t a practice exclusive to business marketing strategies or to the US government’s national security information, as it’s widely utilized across various sectors for diverse types of data. Moreover, far from being outdated, data classification remains a pivotal component of modern data protection strategies, continually evolving to meet the challenges posed by increasing amounts of data and advancing cyber threats.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 19.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      76,
      73,
      89,
      74,
      77
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 4,
    "question": "Simon is a system administrator for a technology firm. His organization has high data modification and transaction rates. They need a RAID solution that offers high read speeds, has fault tolerance for at least one disk failure, and does not require double the storage. Which RAID level should Simon choose for his organization?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 6",
    "correct_answer": "C",
    "explanation": "Simon should choose RAID 5. This RAID level stripes data and parity information across drives. It offers high read speeds and can sustain a single drive failure without losing data, which aligns with the requirements of Simon’s organization. It does not require double the storage, unlike RAID 1, which is a significant advantage in a high data transaction environment. RAID 0, while providing better I/O performance, is not fault tolerant—all data is lost if a drive fails; hence, it is not suitable for Simon’s requirements. RAID 6 is similar to RAID 5 but allows for more than one drive to fail at a time. However, RAID 6 offers slower write performance than RAID 5, as the additional parity data is managed, which might be problematic for an organization with high data modification rates like Simon’s.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 9.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      34,
      32,
      33
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 5,
    "question": "Brianna is concerned about brown-outs and short power outages for her systems in a data center. What type of power protection should she put in place to help keep her systems online?",
    "choice_a": "A generator",
    "choice_b": "Dual-power supplies",
    "choice_c": "PDUs",
    "choice_d": "UPSs",
    "correct_answer": "D",
    "explanation": "An UPS, or uninterruptible power supply, relies on batteries or other stored power to keep systems online during short power outages, and it can provide stable power during power sags and brown-outs. A generator is needed for longer outages because most UPS systems are intended to stay online for only a few minutes. A PDU, or power distribution unit, is used to deliver power to devices. Dual-power supplies are used to ensure that the failure of a single power supply or single power source does not take down a server.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 9.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      34,
      32,
      33,
      31,
      35
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 6,
    "question": "Marcus is evaluating frameworks to support his organization’s GRC program. He needs a framework specifically focused on establishing and maintaining an information security management system (ISMS). Which framework best meets this need?",
    "choice_a": "COBIT",
    "choice_b": "ISO 31000",
    "choice_c": "NIST Cybersecurity Framework",
    "choice_d": "ISO 27001",
    "correct_answer": "D",
    "explanation": "ISO 27001 is an international standard for information security management systems (ISMS) that provides a systematic approach to managing information security risks and ensuring compliance with security requirements. COBIT is focused on IT governance and management, not specifically on ISMS. ISO 31000 provides principles and guidelines for risk management across all types of organizational risk. The NIST CSF is a cybersecurity framework but does not define ISMS requirements the way ISO 27001 does.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.1 and covers material discussed in Chapter 8.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      29,
      27,
      28
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 7,
    "question": "James, a customer service representative at an online retail company, is undergoing a security training program. As part of his role, he frequently communicates with customers, handling their queries and complaints. Which type of training would best equip James to handle social engineering and pretexting attacks that he may encounter in his work?",
    "choice_a": "Role-based training",
    "choice_b": "Anomalous behavior recognition",
    "choice_c": "Hybrid/remote work environment training",
    "choice_d": "Security policy training",
    "correct_answer": "A",
    "explanation": "The correct answer is role-based training. This training approach tailors the training content to the specific job responsibilities of an individual. For a customer service representative like James, the focus would be on nontechnical aspects, particularly on dealing with social engineering and pretexting attacks. Anomalous behavior recognition, while important, is more focused on recognizing unexpected or risky behavior internally and is not specifically tailored to his role. Hybrid remote work environment training and security policy training, although crucial, deal with best practices for remote work security and organizational security policies, respectively, and are not directly related to handling social engineering and pretexting attacks, which are a significant part of James’ job responsibilities.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.3 and covers material discussed in Chapter 11.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      43,
      41,
      42,
      40
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 8,
    "question": "Henry is conducting a penetration test and wants to social-engineer a staff member at his target organization into letting him gain access to a building. He explains that he is there at the request of a senior manager and that he is late for a meeting with that manager, who is relying on him to be there. Which social engineering principle is he using?",
    "choice_a": "Authority",
    "choice_b": "Intimidation",
    "choice_c": "Urgency",
    "choice_d": "Trust",
    "correct_answer": "C",
    "explanation": "Henry is using urgency. If he has expressed the fact that the person could lose their job if they didn’t let him in, he might intimidate them. If he had told them that he was an inspector or enforcement officer, he would have been using perceived authority. Finally, if he exploited their willingness to trust him, he would have used that trust as the foundation of his social engineering attack.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.3 and covers material discussed in Chapter 11.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      41
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 9,
    "question": "Xavier is implementing multifactor authentication and wants to ensure that he is using different factors. The authentication system he is setting up requires a PIN and a biometric factor. What types of factors are these?",
    "choice_a": "Something you know and something you are.",
    "choice_b": "Something you have and something you are.",
    "choice_c": "Something you know and something you have.",
    "choice_d": "They are both the same factor and cannot be used for multifactor authentication.",
    "correct_answer": "A",
    "explanation": "A PIN is something you know, and a biometric factor is something you are. Xavier is correctly using two different types of factors for his authentication scheme. If he were using a PIN and a password, he would be using two of the same type of factor, reducing the overall security for his environment.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.1 and covers material discussed in Chapter 2.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      8
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 10,
    "question": "Phil is investigating a security incident where the attackers shut down his organization’s database server. They do not appear to have actually gained access to the system, but they shut it down using some type of remote exploit. Which principle of cybersecurity was most directly violated during this incident?",
    "choice_a": "Integrity",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Non-repudiation",
    "correct_answer": "C",
    "explanation": "This is an example of an availability breach. By shutting down the database server, the attackers were able to deny authorized users access to the server. Confidentiality was not compromised, as data was not accessed. And since data was not accessed, neither was it changed, keeping data integrity intact. Non-repudiation does not play a role in this scenario, because we are not concerned with proving data source identity to a recipient.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.1 and covers material discussed in Chapter 1.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      3,
      1,
      2
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 11,
    "question": "Ian is designing an authorization scheme for his organization’s deployment of a new accounting system. He is considering putting a control in place that would require that two accountants approve any payment request of over $100,000. Which security principles is Ian seeking to enforce?",
    "choice_a": "Two-person control",
    "choice_b": "Separation of duties",
    "choice_c": "Least privilege",
    "choice_d": "Security through obscurity",
    "correct_answer": "A",
    "explanation": "It is sometimes difficult to distinguish between cases of least privilege, separation of duties, and two-person control. Least privilege means that an employee should have only the access rights necessary to perform their job. That is not the case in this scenario, because accountants need to be able to approve payments. Separation of duties occurs when the same employee does not have permission to perform two different actions that, when combined, could undermine security. That is not the case here, because both employees are performing the same action: approving the payment. Two-person control occurs when two employees must jointly authorize the same action. That is the case in this scenario. Security through obscurity occurs when the security of a control depends on the secrecy of its mechanism.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 3.2 and covers material discussed in Chapter 14.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      49,
      46,
      50,
      98,
      47
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 12,
    "question": "Brady is developing the architecture for a new data loss prevention system that his organization will use to prevent the exfiltration of sensitive information over the network. What category of control is Brady implementing?",
    "choice_a": "Administrative",
    "choice_b": "Technical",
    "choice_c": "Physical",
    "choice_d": "Detective",
    "correct_answer": "B",
    "explanation": "The three control categories on the CC exam are technical, administrative, and physical. Data loss prevention systems use technology to achieve security control objectives and are, therefore, technical controls.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.4 and covers material discussed in Chapter 6.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      20,
      23,
      19,
      18
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 13,
    "question": "Tina recently completed a risk management review and identified that her organization is susceptible to a man-in-the-middle attack. After Tina reviews the situation with her manager, they jointly decide that accepting the risk is the most appropriate strategy. What should Tina do next?",
    "choice_a": "Design a remediation plan",
    "choice_b": "Implement additional security controls",
    "choice_c": "Document the decision",
    "choice_d": "Repeat the business impact assessment",
    "correct_answer": "C",
    "explanation": "After accepting a risk, the organization takes no action other than to document the risk as accepted. Implementing additional security controls or designing a remediation plan would not be risk acceptance but would instead fit into the category of risk mitigation. There is no need to repeat the business impact assessment.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.2 and covers material discussed in Chapter 4.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      15,
      16,
      23
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 14,
    "question": "Gary recently conducted a comprehensive security review of his organization. He identified the 25 top risks to the organization and is pursuing different risk management strategies for each of these risks. In some cases, he is using multiple strategies to address a single risk. His goal is to reduce the overall level of risk so that it lies within his organization’s risk tolerance. Gary decides that the organization should integrate a threat intelligence feed with the firewall. What type of risk management strategy is this?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk mitigation",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk transference",
    "correct_answer": "B",
    "explanation": "The use of a threat intelligence feed to block connections at the firewall reduces the likelihood of a successful attack and is, therefore, a risk mitigation activity. Risk acceptance would be if Gary decided not to implement any measures against the risk. Risk avoidance would be if the organization ceased to conduct business. And risk transference would be if Gary purchased a cyber insurance policy against the risk.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.2 and covers material discussed in Chapter 4.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      15,
      20,
      16
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 15,
    "question": "Gavin is drafting a document that provides a detailed step-by-step process that users can follow to connect to VPN from remote locations. Alternatively, users can ask IT to help them configure the connection. Which term best describes this document?",
    "choice_a": "Policy",
    "choice_b": "Standard",
    "choice_c": "Guideline",
    "choice_d": "Procedure",
    "correct_answer": "D",
    "explanation": "A procedure offers a step-by-step process for completing a cybersecurity activity. The VPN instructions that Gavin is creating are best described using this term. Policies are the overarching security objectives of an organization. Standards follow through on implementing security policies. And guidelines are recommended ways of carrying out a task.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.3 and covers material discussed in Chapter 5.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      19
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 16,
    "question": "Norm would like to create an agreement with a SaaS provider that specifies the amount of downtime that is acceptable. What document would typically contain this type of requirement?",
    "choice_a": "MOU",
    "choice_b": "BPA",
    "choice_c": "MSA",
    "choice_d": "SLA",
    "correct_answer": "D",
    "explanation": "Service level agreements (SLAs) are written contracts that specify the conditions of service that will be provided by the vendor and the remedies available to the customer if the vendor fails to meet the SLA. SLAs commonly cover issues such as system availability, data durability, and response time.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.3 and covers material discussed in Chapter 17.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      66,
      65,
      67
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 17,
    "question": "Tina is applying a digital signature to a contract so that the recipient can prove that she agreed to its terms. What goal of cryptography most directly describes Tina’s actions?",
    "choice_a": "Non-repudiation",
    "choice_b": "Confidentiality",
    "choice_c": "Integrity",
    "choice_d": "Authentication",
    "correct_answer": "A",
    "explanation": "Non-repudiation ensures that individuals can prove to a third party that a message came from its purported sender. Although Tina can also achieve other goals with her approach, this goal is her stated intention.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.1 and covers material discussed in Chapter 1.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      4,
      2,
      1
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 18,
    "question": "Which of the following phrases best describes a man-in-the-browser attack?",
    "choice_a": "A plug-in virus",
    "choice_b": "A plug-in worm",
    "choice_c": "A browser rootkit",
    "choice_d": "A proxy Trojan",
    "correct_answer": "D",
    "explanation": "A browser-based man-in-the-middle (MitM) attack inserts malicious software that intercepts traffic from the browser and modifies for malicious purposes. This is an example of a proxy Trojan. Although this can be implemented as a plug-in, the important element here is that it is a proxy, rather than a rootkit, worm, or virus.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.2 and covers material discussed in Chapter 20.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      78,
      70,
      93,
      92,
      73
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 19,
    "question": "Bart runs a backup service for his organization, and every day he backs up the changes since the last backup operation he performed. Which type of backup is he performing?",
    "choice_a": "Differential",
    "choice_b": "Full",
    "choice_c": "Incremental",
    "choice_d": "Partial",
    "correct_answer": "C",
    "explanation": "Bart is conducting an incremental backup. Differential backups back up all data that has changed since the last full backup. Incremental backups back up the changes since the last full or incremental backup. Full backups back up all data, and partial backups are not a defined technical term.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 10.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      37
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 20,
    "question": "Charles wants to use a lock to secure a high-security area in his organization. He wants to ensure that losing the code to the lock will not result in the lock being easily defeated by someone with that code. Which type of lock should he put in place?",
    "choice_a": "Biometric",
    "choice_b": "Electronic",
    "choice_c": "Physical",
    "choice_d": "Time-based",
    "correct_answer": "A",
    "explanation": "A biometric lock will require the registered user to be present to unlock it. Electronic and physical locks that rely on codes or combinations can be defeated by someone who knows the code, and time-based locks merely control when the lock can be opened and then rely on one of the other three types of locking mechanisms once time-based enforcement is accomplished.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.4 and covers material discussed in Chapter 6.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      8,
      5,
      21,
      20
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 21,
    "question": "As part of her organization’s response and recovery controls, Charlene has implemented a remote site that has all the systems needed to operate her company’s IT infrastructure. In the event of a major outage or issue, she would need to bring copies of data to the site. Which type of disaster recovery site has she set up?",
    "choice_a": "Cold site",
    "choice_b": "Warm site",
    "choice_c": "Hot site",
    "choice_d": "Availability zone",
    "correct_answer": "B",
    "explanation": "A warm site has all the hardware and networking needed to run essential operations, but it does not have the data ready to go. A hot site has everything you need, and you may have to bring just the last data update. A cold site is essentially just space to bring in equipment, networking, and data. Availability zones are a cloud computing concept used by Amazon.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 10.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      38,
      37,
      35,
      31,
      36
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 22,
    "question": "What is the primary difference between a HIDS and a HIPS?",
    "choice_a": "A HIDS can be installed only on servers.",
    "choice_b": "A HIDS can stop attacks, whereas a HIPSs only log them.",
    "choice_c": "A HIPS can only be installed on servers.",
    "choice_d": "A HIDS only logs attacks, whereas a HIPS can stop them.",
    "correct_answer": "D",
    "explanation": "The primary difference between a host-based intrusion detection system (HIDS) and a host-based intrusion prevention system (HIPS) is that an HIPS can stop attacks by dropping or modifying traffic, whereas an HIDS will only log and alert on attacks.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.2 and covers material discussed in Chapter 16.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      54,
      59,
      99,
      53,
      60
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 23,
    "question": "Adam wants to deploy one-time passwords to his staff, and he wants to be able to support many different sites while also providing the ability to enroll users using the MDM system. What tool should he select?",
    "choice_a": "Hardware token",
    "choice_b": "Static codes",
    "choice_c": "An authenticator app",
    "choice_d": "Phone-based push authentication",
    "correct_answer": "C",
    "explanation": "Adam should select an authenticator app. Apps like Google Authenticator, Duo, and Microsoft Authenticator all provide the capabilities that he is looking for. Some hardware tokens can handle multiple sites but are not manageable via MDM. Static codes are just that: printed-out codes. Phone-based push authentication could support multiple sites but is far less secure and, again, is not managed via MDM.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.1 and covers material discussed in Chapter 2.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      8,
      5,
      7
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 24,
    "question": "Ursula wants to allow users to connect to her small organization’s wireless network who do not have organizational credentials, and she wants to allow them to use encryption while on the network. Which of the following options is best suited to her needs?",
    "choice_a": "PSK",
    "choice_b": "Enterprise authentication",
    "choice_c": "An open network",
    "choice_d": "Captive portal authentication",
    "correct_answer": "A",
    "explanation": "Ursula can use a pre-shared key, or PSK. Many small organizations simply put up a sign with the key, allowing encryption without requiring authentication via WPA Enterprise. Captive portals are used when some minimal amount of information needs to be captured before connection but are otherwise an open network in most cases.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.1 and covers material discussed in Chapter 15.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      55,
      56,
      51
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 25,
    "question": "Priya’s manager asks her to create a report that tracks how the organization’s cybersecurity risk levels are trending over time so leadership can spot emerging threats before they become critical. Which of the following would be most useful for this purpose?",
    "choice_a": "An acceptable use policy",
    "choice_b": "Key Risk Indicators (KRIs)",
    "choice_c": "A business impact analysis",
    "choice_d": "A service level agreement",
    "correct_answer": "B",
    "explanation": "Key Risk Indicators (KRIs) are forward-looking, leading indicators that signal increasing risk exposure before incidents occur. They give security teams advance warning, allowing them to take preventive action rather than simply reacting after something goes wrong. An acceptable use policy governs how employees may use organizational resources but does not measure risk trends. A business impact analysis identifies the impact of disruptions to business functions but is not a continuous risk-tracking metric. A service level agreement defines performance expectations between parties but does not track cybersecurity risk levels.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.4 and covers material discussed in Chapter 12.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      44,
      45,
      27,
      30,
      29
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 26,
    "question": "Nathaniel is scanning for SSH servers on his network. Which port and protocol should he scan for to find them?",
    "choice_a": "22/UDP",
    "choice_b": "443/UDP",
    "choice_c": "22/TCP",
    "choice_d": "443/TCP",
    "correct_answer": "C",
    "explanation": "The default SSH port is 22 via TCP. Although some administrators move SSH to a nonstandard port, most invest time in protecting the SSH server and accounts instead.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.1 and covers material discussed in Chapter 15.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      62,
      52,
      60
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 27,
    "question": "Sarah’s security team has recommended that she place the offsite storage facility for her organization’s backups at least 90 miles away from the primary office location. What is the primary driver of this recommendation?",
    "choice_a": "Placing the offsite storage facility 90 miles away prevents theft by making the backups hard to get to for local thieves.",
    "choice_b": "Ninety miles is the minimum distance to prevent latency issues for backups.",
    "choice_c": "Placing the offsite storage facility 90 miles away means a single disaster is unlikely to destroy both the main facility and the backups.",
    "choice_d": "Placing the offsite storage facility 90 miles away ensures that different local jurisdiction laws will apply, making it harder for a single legal case to involve the primary data and the backups.",
    "correct_answer": "C",
    "explanation": "Geographic diversity is an important concept for redundant sites and backup locations. Although the minimum distance considered safe varies based on the guidelines you choose to follow, a distance like this is intended to ensure that a single disaster will be unlikely to destroy both the primary data center or storage location and the backups. Although the remainder of the answers might sound reasonable, they are not actual reasons for this type of geographic dispersion.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 10.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      38,
      32,
      33,
      37,
      35
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 28,
    "question": "Hank has purchased servers that have dual power supplies. How should he connect the power supplies to ensure that systems stay online?",
    "choice_a": "Connect both power supplies to the same UPS or power distribution system.",
    "choice_b": "Connect the power supplies to different UPS or power distribution systems.",
    "choice_c": "Leave one power supply disconnected so that it can be enabled in case of an issue.",
    "choice_d": "Leave one power supply disconnected to avoid providing too much power to the system.",
    "correct_answer": "B",
    "explanation": "A dual power supply system is typically connected to two different power infrastructures, such as UPS and power distribution systems, to ensure that, if one side fails, the server or system will remain online. This is part of designing and building a fully redundant power infrastructure.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 9.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      34,
      32,
      31,
      33,
      38
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 29,
    "question": "Elaine has been asked to choose a physical backup medium to send to an offsite facility as part of her organization’s disaster recovery planning. What is the least expensive commonly used option for reliable mass storage for backups in this scenario?",
    "choice_a": "Hard drives",
    "choice_b": "Tapes",
    "choice_c": "Flash media",
    "choice_d": "Optical media",
    "correct_answer": "B",
    "explanation": "The most common answer to large-scale backups that will be kept in a storage location is to use tapes. Tapes are relatively inexpensive, travel safely, and are available in very high capacities. Hard drives are more fragile; flash media does not come in the volumes needed in many cases and is not available at a cost that fits the usage model if it is high capacity; and optical media does not have the capacity that tape does for commonly available systems.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 10.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      37,
      38,
      35,
      31,
      34
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 30,
    "question": "What security control can be used to clearly communicate to users the level of protection required for different data types?",
    "choice_a": "Classification policies",
    "choice_b": "Retention standards",
    "choice_c": "Lifecycle practices",
    "choice_d": "Compensating controls",
    "correct_answer": "A",
    "explanation": "Classification policies create different categories of data used within an organization and then specify the level of security control required for each classification level. Using classifications helps users understand the type of protection necessary for each data type they encounter.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 19.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      76
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 31,
    "question": "Which two factors are weighted most heavily when determining the severity of a risk?",
    "choice_a": "Likelihood and probability",
    "choice_b": "Likelihood and impact",
    "choice_c": "Magnitude and impact",
    "choice_d": "Impact and control",
    "correct_answer": "B",
    "explanation": "The two factors that determine the severity of a risk are its likelihood and impact. Likelihood is a synonym for probability. Impact is a synonym for magnitude. Controls are a risk mitigation technique that might be applied to reduce the magnitude and/or probability after determining the severity of a risk.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.2 and covers material discussed in Chapter 4.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      16,
      15,
      20,
      23
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 32,
    "question": "Which term best describes data that resides on a hard drive attached to a server?",
    "choice_a": "Data at rest",
    "choice_b": "Data in transit",
    "choice_c": "Data in processing",
    "choice_d": "Data in use",
    "correct_answer": "A",
    "explanation": "Data at rest is stored data that resides on hard drives, on tapes, in the cloud, or on other storage media. Data in processing, or data in use, is data that is actively in use by a computer system. Data being sent over a network is data in transit or data in motion.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 19.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      70,
      73,
      76,
      74,
      88
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 33,
    "question": "Christopher received a message from Renee that was encrypted using an asymmetric encryption algorithm. What key should Christopher use to decrypt the message?",
    "choice_a": "Christopher’s public key",
    "choice_b": "Christopher’s private key",
    "choice_c": "Renee’s public key",
    "choice_d": "Renee’s private key",
    "correct_answer": "B",
    "explanation": "Christopher should use his own private key to decrypt the message. In an asymmetric encryption algorithm, the recipient of a message uses their own private key to decrypt messages that they receive.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 18.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      69,
      68,
      70
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 34,
    "question": "Robin is planning to conduct a risk assessment in her organization. She is concerned that it will be difficult to perform the assessment because she needs to include information about both tangible and intangible assets. What would be the most effective risk assessment strategy for her to use?",
    "choice_a": "A quantitative risk assessment",
    "choice_b": "A qualitative risk assessment",
    "choice_c": "A combination of a quantitative and a qualitative risk assessment",
    "choice_d": "Neither a quantitative nor a qualitative risk assessment",
    "correct_answer": "C",
    "explanation": "Robin would have achieved the best results by combining elements of quantitative and qualitative risk assessment. Quantitative risk assessment excels at analyzing tangible, financial risks, whereas qualitative risk assessment is good for intangible risks. Combining the two techniques provides a well-rounded risk picture.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.2 and covers material discussed in Chapter 4.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      14,
      16,
      18,
      23,
      13
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 35,
    "question": "Jen’s firm is planning to open a new retail store that will accept credit cards. What regulation must the firm comply with as a result of this processing?",
    "choice_a": "FERPA",
    "choice_b": "HIPAA",
    "choice_c": "GLBA",
    "choice_d": "PCI DSS",
    "correct_answer": "D",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) is an industry regulatory framework that specifies the cybersecurity requirements for organizations involved in credit card transactions.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.3 and covers material discussed in Chapter 5.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      17
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 36,
    "question": "Frank’s organization recently suffered an attack in which a senior system administrator executed some malicious commands and then deleted the log files that recorded his activity. Which one of the following controls would best mitigate the risk of this activity recurring in the future?",
    "choice_a": "Two-person control",
    "choice_b": "Job rotation",
    "choice_c": "Security awareness",
    "choice_d": "Segregation of duties",
    "correct_answer": "D",
    "explanation": "Segregation of duties is the most effective way to mitigate this risk. Administrators who have access to perform privileged activities on systems should not also have the ability to alter log files. Two-person control could work but would be very cumbersome. Job rotation and security awareness would not address this risk.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 3.2 and covers material discussed in Chapter 14.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      49,
      46,
      47
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 37,
    "question": "Gary discovers that his organization is storing some old files in a cloud service that are exposed to the world. He deletes those files. What type of risk management strategy is this?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk transference",
    "correct_answer": "C",
    "explanation": "Gary is changing business practices to avoid the risk entirely. Therefore, this is an example of risk avoidance.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.2 and covers material discussed in Chapter 4.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      15
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 38,
    "question": "In a cryptographic system, what component is responsible for providing secrecy?",
    "choice_a": "Message digest",
    "choice_b": "Key",
    "choice_c": "Algorithm design",
    "choice_d": "Algorithm choice",
    "correct_answer": "B",
    "explanation": "In a cryptographic algorithm, only the key (secret key and private key) provide secrecy. All other elements of the cryptographic system can be kept open for public inspection. Strong cryptographic algorithms depend only on the secrecy of the key, not the secrecy of their mechanism.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 18.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      68,
      69,
      70
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 39,
    "question": "Paul is concerned that network devices in his organization might have exposed management interfaces. Which one of the following tests is most likely to discover this vulnerability?",
    "choice_a": "Web application scan",
    "choice_b": "Dynamic application test",
    "choice_c": "Static application test",
    "choice_d": "Network vulnerability scan",
    "correct_answer": "D",
    "explanation": "Exposed management interfaces are a standard test conducted during network vulnerability scans. Application testing of any kind is unlikely to discover this type of vulnerability.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.5 and covers material discussed in Chapter 23.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      92,
      89,
      91
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 40,
    "question": "Renee is responding to a cybersecurity incident at her organization in which the attackers used a botnet to disrupt access to the organization’s website, preventing legitimate customers from placing orders. Which type of attack took place?",
    "choice_a": "Destruction",
    "choice_b": "Alteration",
    "choice_c": "Denial-of-service",
    "choice_d": "Integrity",
    "correct_answer": "C",
    "explanation": "This is an example of a denial-of-service attack that disrupted the availability of the website for legitimate users.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.2 and covers material discussed in Chapter 20.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      87,
      83,
      79,
      78,
      84
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 41,
    "question": "Tarin ran a port scan on a web server hosting her organization’s public website and discovered that it is exposing ports 22, 80, and 443 to the world. Which one of these ports poses the greatest security risk?",
    "choice_a": "22",
    "choice_b": "80",
    "choice_c": "443",
    "choice_d": "None of these ports pose a significant risk",
    "correct_answer": "A",
    "explanation": "Port 22 is used by the Secure Shell (SSH) protocol and should generally never be exposed to public access because it enables brute-force SSH attacks. Ports 80 and 443 are commonly exposed on web servers to provide public web access using HTTP and HTTPS, respectively. Although organizations generally now prefer the use of HTTPS, port 80 remains open for the purposes of redirecting connections to port 443.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.1 and covers material discussed in Chapter 15.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      62,
      57,
      60,
      61,
      63
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 42,
    "question": "Nadean is a software developer who is preparing a new application file that will be deployed to a customer. What key should she use to sign the application?",
    "choice_a": "Her organization’s public key",
    "choice_b": "Her organization’s private key",
    "choice_c": "The customer’s public key",
    "choice_d": "The customer’s private key",
    "correct_answer": "B",
    "explanation": "Digital signatures are always created using the private key of the person or organization creating the digital signature. In this case, Nadean should use her organization’s private key to sign the application.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 18.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      69,
      71,
      70
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 43,
    "question": "In what cloud security model does the cloud service customer bear the most responsibility for implementing security controls?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "PaaS",
    "choice_d": "FaaS",
    "correct_answer": "B",
    "explanation": "The cloud service customer bears the most responsibility for implementing security controls in an infrastructure-as-a-service (IaaS) environment and the least responsibility in a software-as-a-service (SaaS) environment. This is due to the division of responsibilities under the cloud computing shared responsibility model.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.3 and covers material discussed in Chapter 17.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      67,
      66,
      65
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 44,
    "question": "What compliance regulation most directly affects the operations of a healthcare provider?",
    "choice_a": "HIPAA",
    "choice_b": "PCI DSS",
    "choice_c": "GLBA",
    "choice_d": "SOX",
    "correct_answer": "A",
    "explanation": "Although a healthcare provider could be impacted by any of these regulations, the Health Insurance Portability and Accountability Act (HIPAA) provides direct regulations for the security and privacy of protected health information and would have the most direct impact on a healthcare provider.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.3 and covers material discussed in Chapter 5.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      9,
      10,
      11,
      23
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 45,
    "question": "Ujama is deploying a wireless access point for a small business that won’t use enterprise authentication for wireless. What WPA3 feature ensures that the initial key exchange for personal mode is more secure?",
    "choice_a": "MAC",
    "choice_b": "PSK",
    "choice_c": "SAE",
    "choice_d": "IKE",
    "correct_answer": "C",
    "explanation": "SAE (Simultaneous Authentication of Equals) provides a more secure initial key exchange process than PSK (pre-shared keys) did in WPA2. Ujama should implement a WPA3 personal mode network to meet this need. MAC (Media Access Control) addresses are the hardware addresses used for networked devices. IKE (Internet Key Exchange) is part of the IPSec protocol, but it is not used for this.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.1 and covers material discussed in Chapter 15.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      56,
      55,
      51
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 46,
    "question": "Which of the following is the least likely to be a threat created by having an unsecured wireless network?",
    "choice_a": "Intercepting unencrypted data",
    "choice_b": "Spoofing the SSID to conduct a man-in-the-middle attack",
    "choice_c": "Distributed denial-of-service attacks",
    "choice_d": "Undesired access by third parties",
    "correct_answer": "C",
    "explanation": "Unsecured wireless can lead to unencrypted data being intercepted, spoofing of the service set identifier (SSID) resulting in a man-in-the-middle (MitM) attack, or access by third parties. Not securing Wi-Fi is less likely to result in a denial-of-service (DoS)attack, and a distributed denial-of-service attack is even less likely.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.1 and covers material discussed in Chapter 15.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      56,
      55,
      51
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 47,
    "question": "Which one of the following terms best describes the ability of a system to incorporate added capacity as demand increases?",
    "choice_a": "Scalability",
    "choice_b": "Version control",
    "choice_c": "Provisioning",
    "choice_d": "Deprovisioning",
    "correct_answer": "A",
    "explanation": "Scalability says that applications, especially distributed or high-demand systems, should be designed so that computing resources they require can be incrementally added to support increasing demand.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.3 and covers material discussed in Chapter 17.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      64,
      66,
      65
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 48,
    "question": "Gary’s organization wants to ensure that a vendor handles availability and resilience and thus adopts a SaaS tool where the vendor is contractually responsible if issues occur. What type of risk management has occurred?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk transference",
    "correct_answer": "D",
    "explanation": "Gary has transferred the risk by moving it to a third party via a contract. The organization has not directly taken steps to mitigate the risk, has not accepted it, and has not taken steps to avoid it by making sure it doesn’t happen. Instead, they have signed a contract to transfer the risk.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.2 and covers material discussed in Chapter 4.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      23,
      3
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 49,
    "question": "Mike wants to make it harder to break the encryption for a file that needs to stay secure for a number of years. Which of the following solutions should he select?",
    "choice_a": "Digitally sign the file",
    "choice_b": "Increase the key length",
    "choice_c": "Hash the file before encrypting it",
    "choice_d": "Encrypt the file before hashing it",
    "correct_answer": "B",
    "explanation": "A longer key is generally stronger for modern cryptosystems, and a longer key will be harder to crack. Signing the file helps with non-repudiation but not resistance to cracking the encryption. Hashing the file before encrypting it or hashing it after will not help in this scenario.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 18.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      68,
      69,
      72,
      70
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 50,
    "question": "Chris wants to run a RAID that is a mirror of two disks. Which RAID level does he need to implement?",
    "choice_a": "0",
    "choice_b": "1",
    "choice_c": "2",
    "choice_d": "5",
    "correct_answer": "B",
    "explanation": "RAID 1 is a mirror of two disks, with each disk a complete copy of the other disk. RAID 0 is a stripe of two disks and does not help with redundancy, instead focusing on performance. RAID 2 is rarely used and stripes data and uses error correction. RAID 5 stripes by blocks of data and distributes parity information among drives.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 9.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      34,
      32,
      33
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 51,
    "question": "Andrew is working with his financial team to purchase a cybersecurity insurance policy to cover the financial impact of a data breach. What type of risk management strategy is he using?",
    "choice_a": "Risk avoidance",
    "choice_b": "Risk transference",
    "choice_c": "Risk acceptance",
    "choice_d": "Risk mitigation",
    "correct_answer": "B",
    "explanation": "Purchasing insurance is the most common example of risk transference, shifting liability to a third party.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.2 and covers material discussed in Chapter 4.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      15
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 52,
    "question": "Shelly is writing a document that describes the steps that incident response teams will follow up on first notice of a potential incident. What type of document is she creating?",
    "choice_a": "Guideline",
    "choice_b": "Standard",
    "choice_c": "Procedure",
    "choice_d": "Policy",
    "correct_answer": "C",
    "explanation": "Procedures provide checklist-style sets of step-by-step instructions guiding how employees should react in a given circumstance. Procedures commonly guide the early stages of incident response.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.3 and covers material discussed in Chapter 5.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      19
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 53,
    "question": "Chris is responding to a security incident that compromised one of his organization’s web servers. He believes that the attackers defaced one or more pages on the website. What cybersecurity objective did this attack violate?",
    "choice_a": "Confidentiality",
    "choice_b": "Non-repudiation",
    "choice_c": "Integrity",
    "choice_d": "Availability",
    "correct_answer": "C",
    "explanation": "The defacement of a website alters content without authorization and is therefore a violation of the integrity objective. The attackers might also have breached the confidentiality or availability of the website, but the scenario does not provide enough information to draw those conclusions.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.1 and covers material discussed in Chapter 1.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      2,
      1,
      3
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 54,
    "question": "Nolan is writing an after-action report on a security breach that took place in his organization. The attackers stole thousands of customer records from the organization’s database. What cybersecurity principle was most impacted in this breach?",
    "choice_a": "Availability",
    "choice_b": "Non-repudiation",
    "choice_c": "Confidentiality",
    "choice_d": "Integrity",
    "correct_answer": "C",
    "explanation": "The disclosure of sensitive information to unauthorized individuals is a violation of the principle of confidentiality.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.1 and covers material discussed in Chapter 1.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      9,
      11,
      12,
      2
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 55,
    "question": "Fred receives a call to respond to a malware-infected system. When he arrives, he discovers a message on the screen that reads “Send .5 Bitcoin to the following address to recover your files.” What is the most effective way for Fred to return the system to normal operation?",
    "choice_a": "Pay the Bitcoin ransom",
    "choice_b": "Wipe the system and reinstall",
    "choice_c": "Restore from a backup if available",
    "choice_d": "Run anti-malware software to remove malware",
    "correct_answer": "C",
    "explanation": "In most cases, if a backup exists, it is the most effective way to return to normal operation. If no backup exists, Fred may be faced with a difficult choice. Paying a ransom is prohibited by policy in many organizations and does not guarantee that the files will be unlocked. Wiping and reinstalling may result in the loss of data, much like not paying the ransom. Anti-malware software might work, but if it did not detect the malware in the first place, it might not work, or it might not decrypt the files encrypted by the malware.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 10.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      37,
      35,
      36,
      39,
      31
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 56,
    "question": "When a caller was recently directed to Amanda, who is a junior IT employee at her company, the caller informed her that they were the head of IT for her organization and that she needed to immediately disable the organization’s firewall due to an ongoing issue with their e-commerce website. After Amanda made the change, she discovered that the caller was not the head of IT and that it was actually a penetration tester hired by her company. Which social engineering principle best matches this type of attack?",
    "choice_a": "Authority",
    "choice_b": "Consensus",
    "choice_c": "Scarcity",
    "choice_d": "Trust",
    "correct_answer": "A",
    "explanation": "The caller relied on their perceived authority to require Amanda to make the change. They likely also used urgency, which isn’t mentioned here, but that would cause Amanda to potentially skip the validation or verification processes she would have normally used in a scenario like this. There is no effort to build consensus or establish trust, nor is there a sense of scarcity as described in the scenario.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.3 and covers material discussed in Chapter 11.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      41,
      43,
      40
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 57,
    "question": "Mike is sending David an encrypted message using a symmetric encryption algorithm. What key should he use to encrypt the message?",
    "choice_a": "Mike’s public key",
    "choice_b": "Mike’s private key",
    "choice_c": "David’s public key",
    "choice_d": "Shared secret key",
    "correct_answer": "D",
    "explanation": "In symmetric encryption algorithms, both the sender and the receiver use a shared secret key to encrypt and decrypt the message, respectively.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 18.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      69,
      68,
      70
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 58,
    "question": "Theresa wants to implement an access control scheme that sets permissions based on what the individual’s job requires. Which of the following schemes is most suited to this type of implementation?",
    "choice_a": "Attribute-based access control (ABAC)",
    "choice_b": "Discretionary access control (DAC)",
    "choice_c": "Role-based access control (RBAC)",
    "choice_d": "Mandatory access control (MAC)",
    "correct_answer": "C",
    "explanation": "Role-based access control (RBAC) sets permissions based on an individual’s role, which is typically associated with their job. Attribute-based access control (ABAC) is typically matched to attributes other than the job role. Discretionary access control (DAC) and mandatory access control (MAC) are commonly implemented at the operating system level.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 3.2 and covers material discussed in Chapter 14.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      50,
      46,
      49
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 59,
    "question": "What type of access control scheme best describes the Microsoft Windows filesystem?",
    "choice_a": "Mandatory access control (MAC)",
    "choice_b": "Rule-based access control (RuBAC)",
    "choice_c": "Discretionary access control (DAC)",
    "choice_d": "Attribute-based access control (ABAC)",
    "correct_answer": "C",
    "explanation": "Microsoft Windows users can change who can read, write, or execute files and directories they own, which is discretionary access control (DAC). Mandatory access control (MAC) would enforce settings set by the system administrator without users having the rights to make their own decisions. Neither rule-based access control (RBAC) nor attribute-based access control (ABAC) is a default method for setting rights for the Windows filesystem.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 3.2 and covers material discussed in Chapter 14.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      50
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 60,
    "question": "Rick performs a backup that captures the changes since the last full backup. What type of backup has he performed?",
    "choice_a": "A new full backup",
    "choice_b": "A snapshot",
    "choice_c": "An incremental backup",
    "choice_d": "A differential backup",
    "correct_answer": "D",
    "explanation": "Differential backups back up the changes since the last full backup. Incremental backups back up changes since the last backup, and snapshots are a point-in-time copies of a system’s state. This is not a full backup.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 10.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      37
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 61,
    "question": "Ben wants to implement a RAID array that combines both read and write performance while retaining data integrity if a drive fails. Cost is not a concern compared to speed and resilience. What RAID type should he use?",
    "choice_a": "RAID 1",
    "choice_b": "RAID 5",
    "choice_c": "RAID 6",
    "choice_d": "RAID 10",
    "correct_answer": "D",
    "explanation": "RAID 10 (1+0) combines the benefits and downfalls of both RAID 0, striping, and RAID 1, mirroring. In Ben’s use case, where speed and resilience are important and cost is not, striped drives with full copies maintained via the mirror is his best option. RAID 5 and RAID 6 have slower performance, but RAID 5 can survive a loss of a drive and RAID 6 can survive a loss of two drives. RAID 1, mirroring, provides redundancy and read speeds but does not improve write speeds.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 9.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      34,
      32,
      33
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 62,
    "question": "Cynthia wants to clone a virtual machine. What should she do to capture a live machine, including the machine state?",
    "choice_a": "A full backup",
    "choice_b": "A snapshot",
    "choice_c": "A differential backup",
    "choice_d": "A live CD",
    "correct_answer": "B",
    "explanation": "Virtual machine snapshots capture the machine state at a point in time and will allow Cynthia to clone the system. A full backup and a differential backup can be used to capture the disk for the machine but typically will not capture the memory state and other details of the system state. A live CD allows you to boot and run a nonpersistent system from trusted media.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.2 and covers material discussed in Chapter 10.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      37
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 63,
    "question": "Mike wants to stop vehicles from traveling toward the entrance of his building. What physical security control should he implement?",
    "choice_a": "An air gap",
    "choice_b": "A hot aisle",
    "choice_c": "A robotic sentry",
    "choice_d": "A bollard",
    "correct_answer": "D",
    "explanation": "Bollards are physical security controls that prevent vehicles from accessing or ramming doors or other areas. They can look like pillars, planters, or other innocuous objects. An air gap is a physical separation of technology environments; a hot aisle is the aisle where systems in a datacenter exhaust warm air; and, unlike in movies, robotic sentries are not commonly deployed and aren’t ready to stop vehicles in most current circumstances.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.4 and covers material discussed in Chapter 6.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      21,
      20,
      23,
      15,
      14
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 64,
    "question": "Amanda wants to securely destroy data held on DVDs. Which of the following options is not a suitable solution for this?",
    "choice_a": "Degaussing",
    "choice_b": "Crushing and breaking",
    "choice_c": "Pulverizing",
    "choice_d": "Shredding",
    "correct_answer": "A",
    "explanation": "Degaussing only works on magnetic media, and DVDs are optical media. Amanda could crush and break, pulverize, or shred the DVDs to ensure that data is properly destroyed.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 19.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      74,
      88,
      73
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 65,
    "question": "Kevin discovered that his web server was being overwhelmed by traffic, causing a CPU bottleneck. Using the interface offered by his cloud service provider, he added another CPU to the server. Which term best describes Kevin’s actions?",
    "choice_a": "Elasticity",
    "choice_b": "Horizontal scaling",
    "choice_c": "Vertical scaling",
    "choice_d": "High availability",
    "correct_answer": "C",
    "explanation": "This is an example of adding additional capacity to an existing server, which is also known as vertical scaling. Kevin could also have used horizontal scaling by adding additional web servers. Elasticity involves the ability to both add and remove capacity on demand, and, though it does describe this scenario, it’s not as good a description as vertical scaling. There is no mention of increasing the server’s availability.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.3 and covers material discussed in Chapter 17.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      64,
      66,
      65
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 66,
    "question": "Helen designed a new payroll system that she offers to her customers. She hosts the payroll system in AWS, and her customers access it through the web. Which tier of cloud computing best describes Helen’s service to her customers?",
    "choice_a": "PaaS",
    "choice_b": "SaaS",
    "choice_c": "FaaS",
    "choice_d": "IaaS",
    "correct_answer": "B",
    "explanation": "Helen is using IaaS services to create her payroll product. She is then offering that payroll service to her customers as a SaaS solution.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.3 and covers material discussed in Chapter 17.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      66,
      67,
      65
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 67,
    "question": "Which cloud computing deployment model requires the use of a unifying technology platform to tie together components from different providers?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Community cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "D",
    "explanation": "Hybrid cloud environments blend elements of public, private, and/or community cloud solutions. A hybrid cloud requires the use of technology that unifies the different cloud offerings into a single, coherent platform.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.3 and covers material discussed in Chapter 17.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      65
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 68,
    "question": "In which of the following cloud categories are customers charged based on the number of virtual server instances they directly manage?",
    "choice_a": "IaaS only",
    "choice_b": "SaaS only",
    "choice_c": "IaaS and PaaS",
    "choice_d": "IaaS, SaaS, and PaaS",
    "correct_answer": "A",
    "explanation": "Customers are typically charged for virtual server instances in infrastructure-as-a-service (IaaS) environments, where they directly provision and manage those instances. In a platform-as-a-service (PaaS) environment, charges are not based solely on virtual machine counts. In a software-as-a-service (SaaS) environment, the customer typically has no knowledge of the number of server instances supporting their use.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.3 and covers material discussed in Chapter 17.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      66,
      67,
      65
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 69,
    "question": "Brenda’s company provides a managed incident response service to its customers. Which term best describes this type of service offering?",
    "choice_a": "MSP",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "MSSP",
    "correct_answer": "D",
    "explanation": "Brenda’s company is offering a technology service to customers on a managed basis, making it a managed service provider (MSP). However, this service is a security service, so the term managed security service provider (MSSP) is a better description of the situation.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.3 and covers material discussed in Chapter 17.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      66,
      64,
      67,
      60,
      56
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 70,
    "question": "Tony purchases virtual machines from Microsoft Azure and uses them exclusively for use by his organization. What model of cloud computing is this?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "Community cloud",
    "correct_answer": "A",
    "explanation": "This is an example of public cloud computing because Tony is using a public cloud provider, Microsoft Azure. The fact that Tony is limiting access to virtual machines to his own organization is not relevant, because the determining factor for the cloud model is whether the underlying infrastructure is shared, not whether virtualized resources are shared.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.3 and covers material discussed in Chapter 17.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      65,
      67,
      66,
      64
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 71,
    "question": "Naomi has discovered the following TCP ports open on a system she wanted to harden: 21, 22, 80, and 443. Which ports are used for insecure services and thus should be disabled to allow their secure equivalents to continue to be used?",
    "choice_a": "21, 22, and 80",
    "choice_b": "21",
    "choice_c": "21 and 80",
    "choice_d": "22 and 443",
    "correct_answer": "C",
    "explanation": "The services listed are: 21—FTP, 22—SSH, 80—HTTP, 443—HTTPS. Of these services, SSH and HTTPS are secure options for remote shell access and HTTP. Although secure mode FTP (FTP/S) can run on TCP 21, there is not enough information to know for sure, and HTTPS can be used for secure file transfer if necessary. Thus, Naomi’s best option is to disable both insecure protocols: FTP and HTTP.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.1 and covers material discussed in Chapter 15.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      62
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 72,
    "question": "Olivia wants to install a host-based security package that can detect attacks against the system coming from the network, but she does not want to take the risk of blocking the attacks, because she fears that she might inadvertently block legitimate traffic. What type of tool could she install that will meet this requirement?",
    "choice_a": "A host firewall",
    "choice_b": "A host intrusion detection system",
    "choice_c": "A host intrusion prevention system",
    "choice_d": "A data loss prevention tool",
    "correct_answer": "B",
    "explanation": "Olivia should install a host-based intrusion detection system. An intrusion detection system can detect and report on potential attacks but does not have the ability to stop them. A host-based intrusion prevention system can block them. Firewalls can block known ports, protocols, or applications, but they do not detect attacks, although advanced modern firewalls blur the line between firewalls and other defensive tools. Finally, a data loss prevention tool focuses on preventing data exposures, not on stopping network attacks.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.2 and covers material discussed in Chapter 16.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      99,
      60
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 73,
    "question": "Elaine wants to securely erase the contents of a tape used for backups in her organization’s tape library. What is the fastest secure erase method available to her that will allow the tape to be reused?",
    "choice_a": "Use a degausser",
    "choice_b": "Wipe the tape by writing a random pattern of 1s and 0s to it",
    "choice_c": "Incinerate the tape",
    "choice_d": "Wipe the tape by writing all 1s or all 0s to it",
    "correct_answer": "A",
    "explanation": "A degausser is a quick and effective way to erase a tape before it is reused. Wiping a tape by writing 1s, 0s, or a pattern of 1s and 0s to it will typically be a slow operation and is not a common method of destroying data on a tape. Incinerating the tape won’t allow it to be reused.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 19.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      74,
      73
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 74,
    "question": "Daniel’s organization recently issued an acceptable use policy restricting how employees may interact with public AI chatbot services. Daniel is concerned that an employee might paste customer records or proprietary source code into one of these tools, where the information could be retained by the provider or even used to train future models. Which AI risk is Daniel most concerned about?",
    "choice_a": "Data leakage",
    "choice_b": "Model poisoning",
    "choice_c": "Hallucination",
    "choice_d": "Algorithmic bias",
    "correct_answer": "A",
    "explanation": "Data leakage occurs when employees inadvertently share sensitive organizational information such as source code, customer data, or internal documents with public AI services, where it may be retained by the provider or incorporated into the model’s future training. Once that information is submitted, the organization loses control over how it is stored or used, and it can become accessible to other users of the service. Model poisoning is an attack in which an adversary tampers with the data used to train a machine learning model to produce inaccurate results; hallucination occurs when a large language model generates output that sounds plausible but is factually incorrect; algorithmic bias occurs when an AI system produces unfair or discriminatory results due to flaws in its training data or design.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 24.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      67,
      99,
      52,
      66,
      65
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 75,
    "question": "What are the two most commonly deployed biometric authentication solutions for mobile devices?",
    "choice_a": "Voice recognition and face recognition",
    "choice_b": "Fingerprint recognition and gait recognition",
    "choice_c": "Face recognition and fingerprint recognition",
    "choice_d": "Voice recognition and fingerprint recognition",
    "correct_answer": "C",
    "explanation": "Current mobile device implementations have focused heavily on facial recognition via services like Apple’s FaceID and fingerprint recognition like Android’s fingerprint scanning and Apple’s TouchID. Gait recognition is not a widely deployed biometric technology and would be difficult for most mobile device users to use. Voice recognition as a biometric authenticator has not been broadly deployed for mobile devices, whereas voice-activated services are in wide usage.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.1 and covers material discussed in Chapter 2.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      8,
      5,
      4
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 76,
    "question": "Alaina has implemented WPA2 and uses enterprise authentication for access points in infrastructure mode. What encryption protocol is her network using?",
    "choice_a": "WEP",
    "choice_b": "TKIP",
    "choice_c": "CCMP",
    "choice_d": "IV",
    "correct_answer": "C",
    "explanation": "CCMP is the encryption protocol used for WPA2. A block cipher, CCMP provides confidentiality, authentication, and access control features. WEP is the protocol used before WPA; TKIP was used in WPA prior to the use of CCMP in WPA2; and IV is an initialization vector.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.1 and covers material discussed in Chapter 15.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      56,
      55,
      51
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 77,
    "question": "Jerome wants to allow guests to use his organization’s wireless network, but he does not want to provide a pre-shared key. What solution can he deploy to gather information such as email addresses or other contact information before allowing users to access his open network?",
    "choice_a": "WPS capture mode",
    "choice_b": "Kerberos",
    "choice_c": "WPA2",
    "choice_d": "A captive portal",
    "correct_answer": "D",
    "explanation": "Jerome should deploy a captive portal that requires users to provide information before being moved to a network segment that allows Internet access. Wi-Fi protected setup (WPS) capture mode was made up for this question; Kerberos is used for enterprise authentication; and WPA2 supports open, enterprise, or pre-shared key modes but does not provide the capability Jerome needs by itself.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.1 and covers material discussed in Chapter 15.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      55,
      62,
      63,
      60,
      56
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 78,
    "question": "Laura wants to deploy a WPA2 secured wireless environment for her small business, but she doesn’t have a RADIUS server set up. If she wants her Wi-Fi to be encrypted, what is her best option for wireless authentication?",
    "choice_a": "EAP",
    "choice_b": "PSK",
    "choice_c": "EAP-TLS",
    "choice_d": "Open Wi-Fi with a captive portal",
    "correct_answer": "B",
    "explanation": "In small business and home environments, pre-shared keys (PSKs) allow encryption without enterprise authentication and a RADIUS server. Both EAP and EAP-TLS are used in enterprise authentication environments, and open Wi-Fi doesn’t use encryption.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.1 and covers material discussed in Chapter 15.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      55,
      56
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 79,
    "question": "What is the key difference between hashing and checksums?",
    "choice_a": "Both can validate integrity, but a hash also provides a unique digital fingerprint.",
    "choice_b": "A hash can be reversed, but a checksum cannot be.",
    "choice_c": "Checksums provide greater security than hashing.",
    "choice_d": "A checksum has fewer message collisions than a hash.",
    "correct_answer": "A",
    "explanation": "Although both a checksum and a hash can be used to validate message integrity, a hash has fewer collisions than a checksum and will also provide a unique fingerprint for a file. Checksums are primarily used as a quick means of checking that integrity is maintained, whereas hashes are used for many other purposes such as secure password validation without retaining the original password. A checksum would not be useful for proving a forensic image was identical, but it could be used to ensure that your work has not changed the contents of the drive.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 18.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      71
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 80,
    "question": "Joe is authoring a document that explains to system administrators one way in which they might comply with the organization’s requirement to encrypt all laptops. What type of document is Joe writing?",
    "choice_a": "Policy",
    "choice_b": "Guideline",
    "choice_c": "Procedure",
    "choice_d": "Standard",
    "correct_answer": "B",
    "explanation": "The keyword in this scenario is “one way.” This indicates that compliance with the document is not mandatory, so Joe must be authoring a guideline. Policies, standards, and procedures are mandatory.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.3 and covers material discussed in Chapter 5.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      18
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 81,
    "question": "What law creates privacy obligations for those who handle the personal information of European Union residents?",
    "choice_a": "HIPAA",
    "choice_b": "FERPA",
    "choice_c": "GDPR",
    "choice_d": "PCI DSS",
    "correct_answer": "C",
    "explanation": "The General Data Protection Regulation (GDPR) implements privacy requirements for handling the personal information of EU residents. The Health Insurance Portability and Accountability Act (HIPAA) includes security and privacy rules that affect healthcare providers, health insurers, and health information clearinghouses. The Family Educational Rights and Privacy Act (FERPA) applies to educational institutions. The Payment Card Industry Data Security Standard (PCI DSS) applies to credit and debit card information.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.3 and covers material discussed in Chapter 5.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      17,
      9,
      10,
      23,
      19
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 82,
    "question": "Which one of the following documents must normally be approved by the CEO or similarly high-level executive?",
    "choice_a": "Standard",
    "choice_b": "Procedure",
    "choice_c": "Guideline",
    "choice_d": "Policy",
    "correct_answer": "D",
    "explanation": "Policies require approval from the highest level of management, usually the CEO. Other documents can often be approved by other managers, such as the CISO.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.3 and covers material discussed in Chapter 5.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      19,
      23,
      18,
      17,
      16
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 83,
    "question": "Devon wants to give his organization’s executives a single visual summary that shows the current status of key cybersecurity metrics at a glance, using color-coded indicators. Which reporting tool is best suited for this purpose?",
    "choice_a": "Risk register",
    "choice_b": "Audit log",
    "choice_c": "Dashboard",
    "choice_d": "Incident response plan",
    "correct_answer": "C",
    "explanation": "Dashboards are visual displays that present key security metrics in real time or near-real time, typically using charts, graphs, gauges, and color-coded indicators to give viewers an at-a-glance understanding of the organization’s security posture. A risk register documents identified risks and their treatment strategies but is not typically a real-time visual summary tool. An audit log records system events for forensic analysis, not executive reporting. An incident response plan outlines procedures for handling security incidents and is not a reporting tool.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 2.4 and covers material discussed in Chapter 12.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      45,
      44,
      30,
      27,
      28
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 84,
    "question": "Which one of the following policies would typically answer questions about when an organization should destroy records?",
    "choice_a": "Data ownership policy",
    "choice_b": "Account management policy",
    "choice_c": "Password policy",
    "choice_d": "Data retention policy",
    "correct_answer": "D",
    "explanation": "The data retention policy outlines what information the organization will maintain and the length of time different categories of information will be retained prior to destruction.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.1 and covers material discussed in Chapter 19.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      73,
      74,
      76,
      88
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 85,
    "question": "Allan is developing a document that lists the acceptable mechanisms for securely obtaining remote administrative access to servers in his organization. What type of document is Allan writing?",
    "choice_a": "Policy",
    "choice_b": "Standard",
    "choice_c": "Guideline",
    "choice_d": "Procedure",
    "correct_answer": "B",
    "explanation": "Standards describe specific security controls that must be in place for an organization. Allan would not include acceptable mechanisms in a high-level policy document, and this information is too general to be useful as a procedure. Guidelines are not mandatory, so they would not be applicable in this scenario.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.3 and covers material discussed in Chapter 5.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      19,
      21,
      5
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 86,
    "question": "Jen identified a missing patch on a Windows server that might allow an attacker to gain remote control of the system. After consulting with her manager, she applied the patch. From a risk management perspective, what has she done?",
    "choice_a": "Removed the threat",
    "choice_b": "Reduced the threat",
    "choice_c": "Removed the vulnerability",
    "choice_d": "Reduced the vulnerability",
    "correct_answer": "C",
    "explanation": "Jen can reduce the risk associated with the missing patch by taking one of two courses of action. She can either reduce/remove the threat or reduce/remove the vulnerability.<br><br>Jen has no control over what an external attacker does, so she is unable to reduce or remove the threat.<br><br>However, she does have control over the patch status of the system. By applying the patch, Jen has removed the vulnerability from her server. This goes beyond actions that would simply reduce the vulnerability, such as adding an additional firewall.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.4 and covers material discussed in Chapter 22.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      89,
      90,
      88
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 87,
    "question": "Ben is responding to a security incident and determines that the attacker is using systems on Ben’s network to attack a third party. Which of the following containment approaches will prevent Ben’s systems from being used in this manner?",
    "choice_a": "Removal",
    "choice_b": "Isolation",
    "choice_c": "Detection",
    "choice_d": "Segmentation",
    "correct_answer": "A",
    "explanation": "Only the removal of the compromised system from the network will stop the attack against other systems. Segmented systems may still have network connectivity that could allow the attack to continue, and isolated systems, while cut off from the broader network, may not be practical to implement quickly enough to stop an ongoing attack. Detection is a purely passive activity that does not disrupt the attacker at all.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 5.3 and covers material discussed in Chapter 21.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      87,
      83,
      84,
      85,
      86
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 88,
    "question": "Which of the following is not a principle of crime prevention through environmental design?",
    "choice_a": "Natural surveillance",
    "choice_b": "Natural access control",
    "choice_c": "Natural territorial reinforcement",
    "choice_d": "Natural intrusion response",
    "correct_answer": "D",
    "explanation": "The three principles of the crime prevention through environmental design (CPTED) strategy are natural surveillance, natural access control, and natural territorial reinforcement.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.4 and covers material discussed in Chapter 6.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      20,
      26,
      5,
      4,
      24
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 89,
    "question": "Which of the following is not a standard element of visitor control for a typical data center facility?",
    "choice_a": "Visitor logs",
    "choice_b": "Badging",
    "choice_c": "Background checks",
    "choice_d": "Closed-circuit television cameras",
    "correct_answer": "C",
    "explanation": "Standard visitor control systems use logs to record visitor entry and exit, badging to make visitors easily identifiable, and surveillance cameras to monitor activity. Background checks can be performed in extremely sensitive data centers, but typical data centers do not routinely perform background checks on visitors.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.4 and covers material discussed in Chapter 6.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      5,
      4,
      19,
      23,
      20
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 90,
    "question": "Which of the following physical facilities are the most difficult to secure due to their presence throughout a facility?",
    "choice_a": "Wiring closets",
    "choice_b": "Media storage rooms",
    "choice_c": "Evidence storage rooms",
    "choice_d": "Data centers",
    "correct_answer": "A",
    "explanation": "All of these facilities require special security because they contain sensitive electronic equipment. However, wiring closets are often the most difficult to secure because they are located on every floor of every building used by an organization. Data centers, evidence storage rooms, and media storage rooms are normally fewer in number and centrally located.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.4 and covers material discussed in Chapter 6.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      21,
      20,
      19,
      5,
      23
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 91,
    "question": "Shahla is concerned about the security of a sensitive evidence storage room used by her organization’s cybersecurity team. She is creating a policy that two people must be present any time the facility is open. What principle is she enforcing?",
    "choice_a": "Two-person control",
    "choice_b": "Separation of duties",
    "choice_c": "Least privilege",
    "choice_d": "Two-person integrity",
    "correct_answer": "D",
    "explanation": "This is an example of two-person integrity, which requires that two people be present for any access to a sensitive area, such as where valuable items are stored. The presence of two people deters theft or other unauthorized activity by a single person, requiring that they collude with a second individual to carry out illicit activity.<br><br>Two-person control is slightly different. It is used to control access to very sensitive functions, requiring the concurrence of two individuals to carry out an action.<br><br>Shahla is not restricting anyone from having access to the facility, so there is no effect on least privilege. She is also not separating responsibilities for two sensitive privileges, which would be separation of duties.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.4 and covers material discussed in Chapter 6.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      21,
      20,
      19,
      5,
      15
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 92,
    "question": "Which of the following types of accounts almost always violates security best practices?",
    "choice_a": "Administrator",
    "choice_b": "Guest",
    "choice_c": "Shared",
    "choice_d": "Service",
    "correct_answer": "C",
    "explanation": "Shared or generic accounts are accounts where more than one individual has access to use the account. Generally speaking, these accounts are a bad idea. It is difficult to trace who performed an action with a shared account, and every user has plausible deniability when several people have access to an account.<br><br>Administrator accounts are necessary to allow privileged users to carry out their work. Guest accounts provide users with temporary access to resources. Guest accounts should be tied to unique individuals and should expire after a reasonable period of time. Service accounts are a special type of account used internally by a system to run a process or perform other actions. These accounts typically have privileged access and should be carefully controlled.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 3.2 and covers material discussed in Chapter 14.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      49,
      46,
      47,
      98
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 93,
    "question": "Which one of the following technologies most directly achieves the goal of non-repudiation?",
    "choice_a": "Digital signatures",
    "choice_b": "Firewalls",
    "choice_c": "Trusted platform module",
    "choice_d": "Data loss prevention",
    "correct_answer": "A",
    "explanation": "Non-repudiation is a security goal that prevents someone from falsely denying having performed an action or sent a message. Digital signatures use public key cryptography to provide non-repudiation and integrity for electronic documents.<br><br>Firewalls are used to restrict network connections. Trusted platform modules are used to provide hardware key management for computing systems. Data loss prevention systems try to stop unauthorized data theft. None of these technologies achieve the goal of non-repudiation.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.1 and covers material discussed in Chapter 1.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      4
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 94,
    "question": "In a mandatory access control (MAC) system, who or what is responsible for making decisions about the permissions granted to users?",
    "choice_a": "File owners",
    "choice_b": "Operating system",
    "choice_c": "Data owners",
    "choice_d": "System administrators",
    "correct_answer": "B",
    "explanation": "In MAC systems, the operating system itself restricts the permissions that can be granted to users and processes on system resources. Users themselves cannot modify permissions. For this reason, MAC is rarely fully implemented on production systems outside of highly secure environments. MAC is normally implemented as a rule-based access control system where users and resources have labels, and the operating system makes access control decisions by comparing those labels.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 3.2 and covers material discussed in Chapter 14.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      50
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 95,
    "question": "Cathi is reviewing the access permissions granted to several different users and finds that each of them still has permissions they held from a previous job and no longer require. Which principle of cybersecurity was most likely violated?",
    "choice_a": "Two-person control",
    "choice_b": "Separation of duties",
    "choice_c": "Least privilege",
    "choice_d": "Two-person integrity",
    "correct_answer": "C",
    "explanation": "In this situation, the users have permissions that they do not need, making this a clear violation of the least privilege principle.<br><br>The separation of duties principle says that no single person should possess two permissions that, in combination, allow them to perform a sensitive operation. There is no indication that this occurred in this scenario.<br><br>There is no indication that one user is able to perform an action by themselves that would normally require two people, so neither the two-person control nor the two-person integrity principles is violated.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 3.2 and covers material discussed in Chapter 14.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      49,
      47,
      46,
      98
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 96,
    "question": "You learn that another ISC2 certified individual disclosed exam questions to a candidate. Which canon of the ISC2 Code of Ethics was most directly violated?",
    "choice_a": "Canon 1",
    "choice_b": "Canon 2",
    "choice_c": "Canon 3",
    "choice_d": "Canon 4",
    "correct_answer": "D",
    "explanation": "The fourth canon is that your actions as a security professional should advance and protect the information security profession. The actions you take should help rather than detract from the profession at large. The most common way that this canon is violated is when certified individuals provide unauthorized assistance on exams, violate the ISC2 nondisclosure agreement, or provide false information on an applicant’s endorsement application.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.5 and covers material discussed in Chapter 7.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      24,
      26,
      25,
      23,
      19
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 97,
    "question": "You learn that another ISC2 certified individual violated Canon 4 of the Code of Ethics. Who is permitted to file a complaint based on this activity?",
    "choice_a": "Any member of the public",
    "choice_b": "Any certified or licensed individual",
    "choice_c": "The person’s employer",
    "choice_d": "Any ISC2-certified individual",
    "correct_answer": "B",
    "explanation": "Canon 4 is about protecting the profession, so other professionals have standing to file a complaint about Canon 4 violations. This doesn’t mean that you have to be a CISSP or even a security professional. Anyone who is certified or licensed in any field and subscribes to a code of ethics may file a Canon 4 complaint. For example, a certified public accountant or a licensed healthcare professional would both have standing to file a Canon 4 complaint.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.5 and covers material discussed in Chapter 7.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      25,
      24,
      26
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 98,
    "question": "You learn that another ISC2 certified individual is not completing their assigned job responsibilities but is still accepting payment for the work. Which canon of the ISC2 Code of Ethics was most directly violated?",
    "choice_a": "Canon 1",
    "choice_b": "Canon 2",
    "choice_c": "Canon 3",
    "choice_d": "Canon 4",
    "correct_answer": "C",
    "explanation": "The third canon is that the professional services you provide to principals must be both diligent and competent. As a security professional, you must carry out your duties in a responsible manner. The code uses the word “principal” here because it is meant to apply to your employer if you are a normal employee or to your clients if you are a consultant. Basically, whomever you are working for has the right to expect your diligent and competent service. A security professional who fails to carry out their assigned and agreed-upon duties is violating this canon.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 1.5 and covers material discussed in Chapter 7.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      24,
      26,
      23,
      25,
      19
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 99,
    "question": "You are designing a new networking strategy that creates temporary networks for connections between individual systems. What term best describes this strategy?",
    "choice_a": "Micro-segmentation",
    "choice_b": "Site-to-site VPN",
    "choice_c": "Remote access VPN",
    "choice_d": "VLANs",
    "correct_answer": "A",
    "explanation": "Micro-segmentation is an extreme segmentation strategy that uses very small network segments that can be modified often to meet changing business requirements. These network segments can be created temporarily to allow two systems to communicate and then removed when they are no longer needed through dynamic policy rules.<br><br>VLANs can be used to implement micro-segmentation, but the use of VLANs alone does not mean that you are creating these temporary networks.<br><br>There is no indication that any virtual private network (VPN) is being used in this scenario.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.2 and covers material discussed in Chapter 16.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      63,
      61,
      62,
      60,
      99
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 100,
    "question": "You are building a web server for your organization that will have open, public access. Which network is the most appropriate place to locate this server?",
    "choice_a": "Internet",
    "choice_b": "Intranet",
    "choice_c": "Extranet",
    "choice_d": "DMZ",
    "correct_answer": "D",
    "explanation": "The DMZ is a network where you can place systems that must accept connections from the outside world, such as a mail or web server. Those systems are placed in a separate security zone because they have a higher risk of compromise.<br><br>The intranet is used for internal systems that do not require public access. Extranets are used to provide access to vendors and other trusted partners. The Internet zone connects to the outside world and is not an appropriate place to locate a server, because it would be outside the firewall’s protection.<br><br>This question comes from ISC2 Certified in Cybersecurity exam objective 4.2 and covers material discussed in Chapter 16.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      62,
      60,
      63,
      61
    ],
    "source": "454891_Practice_Exam 1"
  },
  {
    "id": 101,
    "question": "Which one of the following security threats would most likely be considered an availability issue?",
    "choice_a": "Replay attack",
    "choice_b": "Power outage",
    "choice_c": "Social engineering",
    "choice_d": "Snooping",
    "correct_answer": "B",
    "explanation": "Availability issues affect authorized users’ ability to access the information, systems, or other resources they need. All of the issues listed here are cybersecurity threats that you need to be aware of when you take the CC exam, but only power outages are classified as an availability threat. This is because a power outage can easily disrupt access to systems and information by bringing them offline.<br><br>Replay attacks allow an unauthorized individual to impersonate a legitimate user and are primarily considered integrity threats.<br><br>Social engineering and snooping attacks may allow an attacker to gain access to sensitive information and are primarily considered confidentiality threats.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      3,
      1,
      2
    ],
    "source": "9781394454907"
  },
  {
    "id": 102,
    "question": "What are the three key goals of information security programs?",
    "choice_a": "Confidentiality, integrity, and availability",
    "choice_b": "Confidentiality, integrity, and authorization",
    "choice_c": "Confidentiality, infrastructure, and authorization",
    "choice_d": "Communications, infrastructure, and authorization",
    "correct_answer": "A",
    "explanation": "The three key goals of any information security program are protecting the confidentiality, integrity, and availability of systems and information.<br><br>Confidentiality ensures that only authorized individuals have access to information and resources. Integrity protects information from unauthorized changes. Availability ensures that information and systems are available for authorized use.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      1,
      2,
      3,
      95
    ],
    "source": "9781394454907"
  },
  {
    "id": 103,
    "question": "You are considering deploying a multi-factor authentication system to protect access to your organization’s virtual private network (VPN). Which one of the following combinations of access controls would meet this requirement?",
    "choice_a": "Password and PIN",
    "choice_b": "Fingerprint and iris scan",
    "choice_c": "Smart card and fingerprint",
    "choice_d": "Key fob and smart card",
    "correct_answer": "C",
    "explanation": "Before you can answer this question, you must identify the authentication factors in use here.<br><br>Passwords and PINs are both examples of something you know.<br><br>Fingerprints and iris scans are both examples of something you are.<br><br>Key fobs and smart cards are both examples of something you have.<br><br>The only answer option that combines factors from two different categories is the use of a smart card (something you have) with a fingerprint (something you are).",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      8
    ],
    "source": "9781394454907"
  },
  {
    "id": 104,
    "question": "Andy is attempting to change his password and has created the following long password:<br><br>p7djkqnr2LAD<br><br>He receives an error message that his password must contain a symbol. Which password policy is he failing to meet?",
    "choice_a": "Password length",
    "choice_b": "Password history",
    "choice_c": "Password complexity",
    "choice_d": "Password reuse",
    "correct_answer": "C",
    "explanation": "This is an example of a password complexity requirement. The message is requiring that Andy use a symbol in his password, and password complexity requirements require the use of different character types.<br><br>There is no indication that Andy is attempting to reuse an old password, which would violate a password history or reuse requirement. There is also no indication that his password is too short and does not meet the password length requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6
    ],
    "source": "9781394454907"
  },
  {
    "id": 105,
    "question": "Which of these people would have the least expectation of privacy?",
    "choice_a": "A patient discussing medical records with a nurse",
    "choice_b": "An employee sending an email to a friend over the office network",
    "choice_c": "A student discussing grades with a teacher",
    "choice_d": "Two people having a private conversation",
    "correct_answer": "B",
    "explanation": "A patient discussing medical records with a nurse is in a situation where there is a strong expectation of privacy. These records are protected health information (PHI) and should be treated very carefully. Of the situations listed, this is likely the one with the greatest expectation of privacy.<br><br>A student discussing grades with a teacher and two people having a private conversation are also in situations where they should have some expectation of privacy.<br><br>An employee of an organization sending an email at work has no expectation of privacy. The employer is entitled to inspect any information sent or received using the office network, even if that information is of a personal nature.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      17,
      19,
      23
    ],
    "source": "9781394454907"
  },
  {
    "id": 106,
    "question": "Norm is reviewing his organization’s privacy practices and observes that the privacy notice is not posted on their website in a location that is accessible to customers. Which PMF component is most directly violated by this action?",
    "choice_a": "Agreement, notice, and communication",
    "choice_b": "Choice and consent",
    "choice_c": "Communication",
    "choice_d": "Collection and creation",
    "correct_answer": "A",
    "explanation": "The second PMF component—agreement, notice, and communication—requires that organizations inform individuals about their privacy practices. One of the criteria for this component includes writing privacy notices in plain and simple language and posting them conspicuously. Norm’s organization is not doing this.<br><br>This does not directly impact the component of choice and consent or collection and creation.<br><br>Communication seems like an obvious answer here, but it is not one of the nine PMF components.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      10
    ],
    "source": "9781394454907"
  },
  {
    "id": 107,
    "question": "Grace recently completed a risk assessment of her organization’s exposure to data breaches and determined that there is a high risk of loss of sensitive personal information from a type of attack called SQL injection. She is considering a variety of approaches to managing this risk.<br><br>Grace’s first idea is to add a web application firewall to protect her organization against SQL injection attacks. Which risk management strategy does this approach adopt?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "C",
    "explanation": "Installing new controls or upgrading existing controls is an effort to reduce the likelihood and/or impact of a risk. This is an example of a risk mitigation activity because it is designed to reduce the likelihood and/or impact of a risk.<br><br>If Grace were to take a risk acceptance strategy, she would simply acknowledge that her organization was vulnerable to SQL injection attacks and take no further action.<br><br>If Grace wanted to pursue risk avoidance, she would shut down any systems that might be vulnerable to SQL injection attacks.<br><br>If Grace wanted to pursue risk transference, she would transfer the potential financial burden of the risk to a third party, such as by purchasing an insurance policy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      20,
      21
    ],
    "source": "9781394454907"
  },
  {
    "id": 108,
    "question": "Your organization is planning to accept credit cards for the first time, and you are concerned about the regulations that may affect card processing. You already handle a large amount of personally identifiable information (PII). Which new regulation is most likely to affect your organization?",
    "choice_a": "GDPR",
    "choice_b": "PCI DSS",
    "choice_c": "CCPA",
    "choice_d": "HIPAA",
    "correct_answer": "B",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS), which regulates the storage, processing, and transmission of credit and debit card information, would most likely apply in this scenario.<br><br>The European Union’s General Data Protection Regulation (GDPR) and the California Consumer Privacy Act (CCPA) may also apply to this information, depending on where the organization operates. However, this would not be a new regulation because the organization already processes other PII, and both GDPR and CCPA would apply if the company operates in the European Union and/or California.<br><br>The Health Insurance Portability and Accountability Act (HIPAA) governs protected health information (PHI). There is no indication in this question that any health records are involved.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      17,
      10,
      11,
      23,
      19
    ],
    "source": "9781394454907"
  },
  {
    "id": 109,
    "question": "You are writing a document that explains the step-by-step process that your organization’s help desk should follow when helping a user reset a forgotten password. Which type of document are you creating?",
    "choice_a": "Policy",
    "choice_b": "Standard",
    "choice_c": "Procedure",
    "choice_d": "Framework",
    "correct_answer": "C",
    "explanation": "The key to answering this question correctly is noticing that the document is a step-by-step process. This type of process should be documented in a procedure.<br><br>Security policies are high-level documents that do not contain technical details and certainly would not include the specific steps followed by a help desk. Standards normally describe technical requirements for information and systems. Frameworks, such as the NIST Cybersecurity Framework (CSF), provide a structured approach to managing cybersecurity programs but are not step-by-step operational documents.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      19,
      7,
      20,
      21,
      18
    ],
    "source": "9781394454907"
  },
  {
    "id": 110,
    "question": "Tonya is concerned about the risk that an attacker will attempt to gain access to her organization’s database server. She is searching for a control that would block the attacker’s attempts to gain access. Which type of security control is she seeking to implement?",
    "choice_a": "Technical",
    "choice_b": "Detective",
    "choice_c": "Corrective",
    "choice_d": "Preventive",
    "correct_answer": "D",
    "explanation": "Tonya is attempting to stop the attacker from gaining access to a system in the first place, so this is an example of a preventive control. She hopes to prevent a security incident.<br><br>Corrective controls are used to remediate security issues that have already occurred. If an attacker compromised a system and Tonya rebuilt it to restore it, that would be a corrective control.<br><br>Detective controls identify potential security breaches. If Tonya installed an intrusion detection system that alerted her to compromised systems, that would be an example of a detective control.<br><br>It is possible that Tonya may deploy a technical control, but all we know from this scenario is the purpose of the desired control: to prevent compromises. No mechanism of action is specified for that preventive control.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      21,
      20,
      5
    ],
    "source": "9781394454907"
  },
  {
    "id": 111,
    "question": "Tonya evaluated all available options for protecting her database and decided to implement strong encryption to protect its contents. Which mechanism of action is she using?",
    "choice_a": "Technical",
    "choice_b": "Administrative",
    "choice_c": "Preventive",
    "choice_d": "Physical",
    "correct_answer": "A",
    "explanation": "Technical controls use technology to achieve security objectives. In this scenario, Tonya is using encryption to protect the contents of her database, thereby implementing a technical control.<br><br>Administrative controls are policies and processes put in place to manage technology securely. There is no discussion of processes in this scenario, so Tonya is not implementing an administrative control.<br><br>Physical controls are those that impact the physical world. Encryption is a digital technology and does not impact the physical world, so it is not a physical control.<br><br>This use of encryption is a preventive control, but preventive is a purpose type, not a mechanism of action category. The question specifically asked for the mechanism of action.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      21,
      20,
      12
    ],
    "source": "9781394454907"
  },
  {
    "id": 112,
    "question": "You are the supervisor of a team of cybersecurity professionals, all of whom hold current ISC2 certifications. You believe that one of those employees has stolen funds from your organization, and an internal investigation confirmed the likelihood of that action. Which two canons of the Code of Ethics were most likely violated?",
    "choice_a": "Canons I and II",
    "choice_b": "Canons II and III",
    "choice_c": "Canons III and IV",
    "choice_d": "Canons I and IV",
    "correct_answer": "B",
    "explanation": "Canon I is that you must protect society, the common good, necessary public trust and confidence, and the infrastructure. Although stealing from an employer is certainly unethical, it likely doesn’t rise to the level of harming society described in this question.<br><br>Canon II is that you must act honorably, honestly, justly, responsibly, and legally. In this case, the employee who stole certainly did not act in accordance with these principles. Based on this information alone, you can select the answer “Canons II and III” because it is the only one that includes Canon II, but let’s continue the analysis to confirm.<br><br>Canon III requires you to provide diligent and competent service to principals (such as your employer). Stealing from your employer is certainly not competent service, so there is a good argument that Canon III was violated.<br><br>Canon IV requires you to advance and protect the profession. As with the Canon I analysis, the employee’s behavior was certainly unethical, but it doesn’t rise to the level of harming the profession.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      24,
      26,
      25
    ],
    "source": "9781394454907"
  },
  {
    "id": 113,
    "question": "You have witnessed behavior by a certified cybersecurity professional and ISC2 member that you believe directly harms the cybersecurity profession. Who has standing to file a complaint about this behavior?",
    "choice_a": "Any member of the public",
    "choice_b": "Any certified professional",
    "choice_c": "The individual’s employer or consulting client",
    "choice_d": "Nobody",
    "correct_answer": "B",
    "explanation": "To answer this question, you must first identify which canon of the ISC2 Code of Ethics is involved. Canon IV of the code is to “Advance and protect the profession,” which seems to match the scenario provided here.<br><br>Next, you must know who has standing to file a complaint under that particular canon. According to the complaint procedures, any certified professional may file a complaint under Canon IV.<br><br>Any member of the public is entitled to file an ethics complaint under Canons I and II but not under Canon IV.<br><br>An individual’s employer or consulting client may file an ethics complaint under Canon III but not under Canon IV.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      25,
      24,
      26
    ],
    "source": "9781394454907"
  },
  {
    "id": 114,
    "question": "Your organization currently manages governance, risk management, and compliance as three separate programs, each with its own team, documentation, and reporting structure. Leadership is considering integrating these into a unified GRC program. Which of the following is the most significant benefit of this integration?",
    "choice_a": "It eliminates the need for compliance audits.",
    "choice_b": "It reduces duplication of effort and aligns security activities with business objectives.",
    "choice_c": "It transfers all organizational risk to a third party.",
    "choice_d": "It replaces the need for security policies and standards.",
    "correct_answer": "B",
    "explanation": "The most significant benefit of integrating governance, risk management, and compliance into a unified GRC program is that it reduces duplication of effort and aligns security activities with business objectives. When these disciplines operate in silos, organizations often perform redundant assessments and maintain duplicate documentation.<br><br>GRC integration does not eliminate the need for compliance audits (A), as audits remain an important verification mechanism. It does not transfer all risk to a third party (C); that would be risk transfer, which is a specific risk response strategy, not a benefit of GRC integration. GRC programs rely on security policies and standards (D) and do not replace them.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      28,
      27,
      30,
      29,
      45
    ],
    "source": "9781394454907"
  },
  {
    "id": 115,
    "question": "A security analyst is evaluating frameworks to help establish an IT governance program for her organization. Which of the following frameworks would be most appropriate for this purpose?",
    "choice_a": "PCI DSS",
    "choice_b": "ISO 31000",
    "choice_c": "COBIT",
    "choice_d": "GDPR",
    "correct_answer": "C",
    "explanation": "COBIT is specifically designed for the governance and management of enterprise IT. It provides a comprehensive framework of controls and processes that align IT activities with business objectives.<br><br>PCI DSS (A) is a compliance standard for organizations that handle payment card data, not an IT governance framework. ISO 31000 (B) is a risk management standard that applies to all types of organizational risk; it is valuable for risk management but is not specifically focused on IT governance. GDPR (D) is a European Union regulation governing data protection and privacy, not a governance framework.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      29,
      27,
      28
    ],
    "source": "9781394454907"
  },
  {
    "id": 116,
    "question": "Renee would like to add fault tolerance to the storage capacity of a new server that she is building. She would like to use RAID 5 to protect this server. What is the minimum number of physical disks that she can use?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "5",
    "correct_answer": "C",
    "explanation": "RAID 5, also known as disk striping with parity, uses three or more disks and writes data across all of those disks but includes additional elements known as parity blocks spread across the disks. If one of the disks fails, the system can regenerate its contents by using that parity information. Therefore, the minimum number of disks required is three.<br><br>It is not possible to use one or two disks with RAID 5 because at least three disks are required to distribute both data and parity across the array.<br><br>It is possible to use RAID 5 with five disks, but that is more than the minimum necessary to support the technology.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      34
    ],
    "source": "9781394454907"
  },
  {
    "id": 117,
    "question": "Kevin is designing a new web server environment for his organization. He believes that the service will need three servers to support normal traffic levels and decides to use three servers to meet that need. As requests come in, they will be sent to the server that has the most available capacity. Which term best describes what Kevin is doing?",
    "choice_a": "Fault tolerance",
    "choice_b": "High availability",
    "choice_c": "Dual power supplies",
    "choice_d": "Load balancing",
    "correct_answer": "D",
    "explanation": "Load balancing uses multiple systems to spread the burden of providing service across those systems, providing a scalable computing environment. Kevin is adding multiple servers that will share the load, so he is achieving load balancing.<br><br>If Kevin were to add more servers than necessary, that would be high availability. For example, if there were four servers, the environment would still be able to meet the full demand even if one of those servers failed. Since Kevin is only adding the three servers required to meet the load, this situation does not meet the definition of high availability.<br><br>Fault tolerance is when you add redundant components to a single server to reduce the likelihood that it will fail. Dual power supplies are an example of fault tolerance. The question does not mention dual power supplies or any other fault tolerance technology.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      33,
      34,
      32
    ],
    "source": "9781394454907"
  },
  {
    "id": 118,
    "question": "Gene recently conducted an assessment and determined that his organization can be without its main transaction database for up to two hours before unacceptable business damage occurs. Therefore, the goal of his organization is to restore service within two hours. Which metric has Gene identified?",
    "choice_a": "RSL",
    "choice_b": "RTO",
    "choice_c": "RPO",
    "choice_d": "MTTR",
    "correct_answer": "B",
    "explanation": "The recovery time objective (RTO) is the time-based goal for restoring service after a disruption. Gene is setting the RTO at two hours to meet his organization’s business needs.<br><br>The recovery point objective (RPO) is the maximum time period from which data may be lost as a result of a disaster, not the goal for restoring service.<br><br>The recovery service level (RSL) is the percentage of a service that must be available during a disaster, not the amount of time that may be taken to restore service.<br><br>The mean time to repair (MTTR) is the average amount of time required to repair a device and is not a goal for future recovery efforts.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      36,
      31,
      35,
      38,
      44
    ],
    "source": "9781394454907"
  },
  {
    "id": 119,
    "question": "Which type of recovery site has some or most systems in place but lacks the data needed to take over operations?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cloud site",
    "choice_d": "Cold site",
    "correct_answer": "B",
    "explanation": "Warm sites have systems, connectivity, and power, but they do not have the up-to-the-minute data to immediately take over operations.<br><br>A hot site can immediately take over operations, whereas a cold site has the space, power, and likely connectivity but requires systems and data to be put in place before use.<br><br>Cloud sites are not one of the three common types of recovery sites.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      38,
      36,
      35,
      37,
      32
    ],
    "source": "9781394454907"
  },
  {
    "id": 120,
    "question": "As a part of your company’s security education program, you are asked to update the security training material. What is the main reason for keeping the training material updated?",
    "choice_a": "To maintain the interest of the trainees",
    "choice_b": "To ensure the training material remains relevant in an evolving threat landscape",
    "choice_c": "To provide a refresher course for the employees",
    "choice_d": "To cover more security topics in the training",
    "correct_answer": "B",
    "explanation": "While maintaining interest, providing refresher courses, and covering more topics can be beneficial, the main reason for keeping training material updated is to ensure it remains relevant in an evolving threat landscape. The nature of cyber threats is constantly changing, and outdated training material might leave employees unprepared to deal with new types of security threats.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      43,
      40,
      41,
      42,
      28
    ],
    "source": "9781394454907"
  },
  {
    "id": 121,
    "question": "A person contacts your help desk pretending to be a top executive’s assistant and demands immediate assistance in resetting the executive’s password. The person warns that the executive will be very upset if their request isn’t fulfilled promptly. Which social engineering tactic is being used?",
    "choice_a": "Intimidation",
    "choice_b": "Consensus and social proof",
    "choice_c": "Familiarity and liking",
    "choice_d": "Scarcity",
    "correct_answer": "A",
    "explanation": "The scenario presents a situation where a person posing as an executive’s assistant leverages the potential of the executive’s anger to compel the help desk to act quickly on their demand. This tactic, where a threat or fear is used to manipulate the victim into compliance, is known as intimidation. Consensus and social proof would involve claiming that others have already approved or followed the same action. Familiarity and liking would rely on building trust through friendliness, shared connections, or personal rapport. Scarcity would involve suggesting that a limited opportunity or resource will disappear unless action is taken quickly.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      41,
      43,
      40
    ],
    "source": "9781394454907"
  },
  {
    "id": 122,
    "question": "Your organization’s security team tracks the number of Internet-facing systems with unpatched critical vulnerabilities. This metric has been steadily increasing over the past three months. What type of metric is this?",
    "choice_a": "Key performance indicator (KPI)",
    "choice_b": "Key risk indicator (KRI)",
    "choice_c": "Scorecard rating",
    "choice_d": "Compliance metric",
    "correct_answer": "B",
    "explanation": "The number of unpatched critical vulnerabilities on Internet-facing systems is a key risk indicator (KRI). KRIs are forward-looking metrics that signal increasing risk exposure. An increasing number of unpatched systems indicates growing risk of a breach.<br><br>KPIs, by contrast, measure past performance against goals. A scorecard rating is a periodic assessment, not a specific metric type. A compliance metric measures adherence to regulations, not future risk.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      44,
      45,
      28,
      27,
      29
    ],
    "source": "9781394454907"
  },
  {
    "id": 123,
    "question": "The CISO wants to present a quarterly assessment of the organization’s cybersecurity posture to the board of directors, organized around the NIST Cybersecurity Framework (CSF) core functions. Which reporting tool is most appropriate for this purpose?",
    "choice_a": "A real-time security operations center (SOC) dashboard",
    "choice_b": "A cybersecurity scorecard",
    "choice_c": "An operational incident report",
    "choice_d": "A vulnerability scan export",
    "correct_answer": "B",
    "explanation": "A cybersecurity scorecard is the best choice for presenting a periodic assessment organized around a framework like the NIST CSF. Scorecards are designed to benchmark an organization’s posture against defined objectives and present results in a format accessible to nontechnical audiences, like a board of directors.<br><br>A SOC dashboard focuses on real-time operational monitoring, not periodic assessment. An operational incident report provides detailed incident analysis, not a framework-based cybersecurity posture assessment. A vulnerability scan export is raw technical data, not an executive-level communication tool.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      45,
      44,
      28,
      27,
      29
    ],
    "source": "9781394454907"
  },
  {
    "id": 124,
    "question": "A new employee joins the marketing department and needs access to the organization’s content management system, social media tools, and shared file repository. Which stage of the identity life cycle determines the specific set of permissions this employee should receive?",
    "choice_a": "Deprovisioning",
    "choice_b": "Review",
    "choice_c": "Roles definition",
    "choice_d": "Provisioning",
    "correct_answer": "C",
    "explanation": "Roles definition is the stage of the identity life cycle that determines what access each job function requires. The marketing role would have a predefined set of permissions that includes access to the content management system, social media tools, and shared file repository.<br><br>Provisioning is the process of actually creating the account and granting that access, but the specific permissions are determined by the roles definition. Review evaluates whether existing access is still appropriate, and deprovisioning removes access.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      46,
      50,
      49
    ],
    "source": "9781394454907"
  },
  {
    "id": 125,
    "question": "During a quarterly access review, a manager discovers that an employee who transferred from the finance department to the sales department six months ago still has access to the financial reporting system. What security principle has been violated?",
    "choice_a": "Separation of duties",
    "choice_b": "Least privilege",
    "choice_c": "Need to know",
    "choice_d": "Defense in depth",
    "correct_answer": "B",
    "explanation": "The principle of least privilege requires that users have only the minimum access necessary to perform their current job duties. The employee who transferred to sales no longer needs access to the financial reporting system, so retaining that access violates least privilege. A role change review should have removed the old finance permissions when the employee moved to sales.<br><br>Separation of duties involves dividing critical tasks among multiple people. Need to know is related but refers specifically to information access based on job requirements. Defense in depth involves layering multiple security controls.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      49,
      47,
      46
    ],
    "source": "9781394454907"
  },
  {
    "id": 126,
    "question": "You are designing an access control system where each file is owned by an individual user and that user decides who can access the file. Which term best describes this access control system?",
    "choice_a": "MAC",
    "choice_b": "RBAC",
    "choice_c": "DAC",
    "choice_d": "ABAC",
    "correct_answer": "C",
    "explanation": "This is an example of a discretionary access control (DAC) system. The defining characteristic of a DAC system is that the owners of individual files can grant other users access to those files.<br><br>In a mandatory access control (MAC) system, file permissions are managed by the operating system and cannot be modified by individual users.<br><br>In a role-based access control (RBAC) system, users are assigned to roles based on their job responsibilities, and then permissions are granted to those roles.<br><br>In an attribute-based access control (ABAC) system, users are granted access to resources based on attributes assigned to their accounts. While ABAC is an incorrect answer choice used in this question, it is not specifically covered by the CC exam objectives.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      50
    ],
    "source": "9781394454907"
  },
  {
    "id": 127,
    "question": "A financial services company wants to ensure that no single employee can both create a new vendor account in the payment system and approve payments to that vendor. Which security principle is the company implementing?",
    "choice_a": "Principle of least privilege",
    "choice_b": "Discretionary access control",
    "choice_c": "Separation of duties",
    "choice_d": "Role-based access control",
    "correct_answer": "C",
    "explanation": "The company is implementing the separation of duties principle by ensuring that the ability to create vendor accounts and approve payments is assigned to different employees. This prevents a single person from creating a fictitious vendor and then authorizing payments to that vendor, which is a common fraud scenario.<br><br>The principle of least privilege limits users to the minimum permissions needed for their jobs, but it does not specifically address splitting sensitive tasks between multiple people. Discretionary access control is a model where resource owners control access permissions. Role-based access control assigns permissions based on job roles, which could be used to implement separation of duties, but is not itself the principle being described.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      49,
      50,
      46
    ],
    "source": "9781394454907"
  },
  {
    "id": 128,
    "question": "You are assigning a host address to a new system on a network using static IP addressing. Which one of the following is a valid IP address?",
    "choice_a": "12.274.16.4",
    "choice_b": "127.19.6.200",
    "choice_c": "194.243.129.144",
    "choice_d": "240.1.15.2",
    "correct_answer": "C",
    "explanation": "You can walk through the three rules of valid IP addresses and answer this question by process of elimination. If you rule out any invalid IP addresses, you are left with the one valid address. First, no value in an IP address should ever be higher than 255. That eliminates the first option because it contains the value 274.<br><br>Second, the first value in a host address should never be 127. That eliminates the second option.<br><br>And finally, the first value in a host address should never exceed 223. That eliminates the last option, which contains the 240 octet value. That leaves one valid address: 194.243.129.144.<br><br>You should be prepared to answer questions like this one when you take the CC exam. If you see a question like this, be sure to read it carefully. Depending on how the question is phrased, it might ask you to identify which address in a set is valid or which is invalid. Don’t get tricked by assuming what the question is asking before you read the entire thing.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      53
    ],
    "source": "9781394454907"
  },
  {
    "id": 129,
    "question": "Tom is configuring a Wi-Fi network for a user who will be working from home. He would like to configure the network so that it is as strongly protected from eavesdropping as possible. Which encryption standard should Tom use?",
    "choice_a": "WEP",
    "choice_b": "WPA2",
    "choice_c": "WPA3",
    "choice_d": "WPA4",
    "correct_answer": "C",
    "explanation": "Tom should use WPA3 because it is the strongest available Wi-Fi encryption standard.<br><br>The WPA2 protocol is also acceptable for modern networks, but it is not as strong as WPA3, making WPA3 a better choice.<br><br>The WEP protocol is outdated and no longer considered secure; it should not be used.<br><br>The WPA4 protocol does not yet exist.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      56
    ],
    "source": "9781394454907"
  },
  {
    "id": 130,
    "question": "You are concerned about unauthorized access to your internal network and would like to use a network device to restrict it. Which one of the following devices would best meet this need?",
    "choice_a": "Firewall",
    "choice_b": "Router",
    "choice_c": "Switch",
    "choice_d": "Access point",
    "correct_answer": "A",
    "explanation": "Looking at this question, you should be able to immediately eliminate two of the answer choices. Switches are components of an internal network; they are not connected to external networks and would not be used to control access into a network. Wireless access points are also internal network components used to connect wireless devices to the wired network. You can eliminate both of these options as possible answer choices.<br><br>That leaves two devices that do connect to external networks: firewalls and routers. The reality is that both firewalls and routers have the potential to fulfill this requirement. They both have filtering capabilities that can block unwanted external traffic. To answer this question correctly, focus on the word best that appears in the final sentence. The question is not asking which device can meet this need; it’s asking which device can best meet this need. While routers do have limited filtering capability, they are not designed for this purpose. Firewalls, on the other hand, are designed specifically to restrict network traffic, making a firewall the best solution to this problem.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      62,
      60,
      61,
      63,
      99
    ],
    "source": "9781394454907"
  },
  {
    "id": 131,
    "question": "You are placing a new server on your organization’s network. The server will host a public website and needs to be accessed by both internal employees and the public. What is the most appropriate network zone for this server?",
    "choice_a": "Internet",
    "choice_b": "DMZ",
    "choice_c": "Intranet",
    "choice_d": "Extranet",
    "correct_answer": "B",
    "explanation": "The key to answering this question correctly is realizing that the server requires public access. Any server in your organization that will be accessed by the general public should be placed in the DMZ.<br><br>Servers should never be placed in the Internet zone, as this zone is completely unprotected by the firewall.<br><br>Servers should be placed on the intranet if they will be accessed only by internal users. Since this server must also be accessed by the general public, it is not appropriate to place it on the intranet.<br><br>Servers should be placed on an extranet if they will be accessed only by internal users and vendor partners. Since this server must also be accessed by the general public, it is not appropriate to place it on the extranet.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      62,
      60,
      63,
      61,
      59
    ],
    "source": "9781394454907"
  },
  {
    "id": 132,
    "question": "Your organization is shifting a series of workloads from an on-premises data center to the cloud. You are working with a vendor that allows you to start up virtual server instances as needed, and then you configure those servers to meet your business requirements. Which cloud service category does this describe?",
    "choice_a": "PaaS",
    "choice_b": "SaaS",
    "choice_c": "DaaS",
    "choice_d": "IaaS",
    "correct_answer": "D",
    "explanation": "This is an example of an infrastructure as a service (IaaS) cloud offering because the service provider is offering you virtual server instances (a core infrastructure component), and then you are configuring those server instances to meet the needs of your organization.<br><br>In a software as a service (SaaS) approach, the provider would sell you a complete application that runs in the cloud, and you would not configure any of the underlying infrastructure yourself.<br><br>In a platform as a service (PaaS) approach, the provider would allow you to run your own application code on a platform that they manage. You still would not manage any of the underlying infrastructure.<br><br>Finally, in a desktop as a service (DaaS) offering, the cloud provider offers end-user productivity desktops that users can use in place of personal computers. That is not the situation described in this scenario.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      66,
      67,
      64
    ],
    "source": "9781394454907"
  },
  {
    "id": 133,
    "question": "Your organization recently signed a contract with a major IaaS provider for services that will be provided in a multitenancy model. As part of the setup process, you are working with the provider to run a dedicated fiber connection directly from your organization’s headquarters campus to the cloud provider’s data center. Which cloud deployment model are you using?",
    "choice_a": "Private cloud",
    "choice_b": "Community cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "Public cloud",
    "correct_answer": "D",
    "explanation": "The key to answering this question correctly is to note that the services are provided in a multitenancy environment. This means that many different customers are sharing the same hardware and that this is a public cloud service offering.<br><br>A private cloud approach would use resources dedicated only to your organization and would not be multitenant. You do have a dedicated, private fiber connection to the cloud provider, but the cloud service being provided is still a public cloud offering.<br><br>There is no indication in the scenario that you are using these services in conjunction with a private cloud, which would make it a hybrid approach, or that you are using an offering open only to customers with a common background, which would make it a community cloud model.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      65
    ],
    "source": "9781394454907"
  },
  {
    "id": 134,
    "question": "You are concerned that users traveling with laptops will have those devices stolen while in transit. Which encryption technology would best protect the data stored on those laptops?",
    "choice_a": "HTTPS",
    "choice_b": "HTTP",
    "choice_c": "VPN",
    "choice_d": "FDE",
    "correct_answer": "D",
    "explanation": "This question is asking you to identify an encryption technology that will protect data at rest and, in particular, the entire contents of a laptop. Full-disk encryption (FDE) is designed for this use case. FDE encrypts an entire hard drive, rendering the contents inaccessible to an unauthorized individual who steals or finds the device.<br><br>HTTP is not an encrypted protocol. HTTPS is a secure, encrypted alternative to HTTP, but it is used to protect web traffic, which is an example of data in transit, and would not be effective in protecting a lost or stolen laptop.<br><br>Similarly, virtual private networks (VPNs) protect network communications and would not be effective in protecting a lost or stolen laptop.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      70,
      68,
      69,
      73,
      76
    ],
    "source": "9781394454907"
  },
  {
    "id": 135,
    "question": "You have a group of remote users who need to access the corporate network from their homes. You would like to protect the information that they send back and forth to the corporate network, regardless of the application that they use. Which encryption technology would best meet this need?",
    "choice_a": "HTTPS",
    "choice_b": "HTTP",
    "choice_c": "VPN",
    "choice_d": "FDE",
    "correct_answer": "C",
    "explanation": "You can begin by eliminating full-disk encryption (FDE) as an answer choice because FDE is designed to protect the contents of a disk—data at rest. It does not protect data in transit over a network.<br><br>The HTTP protocol is unencrypted, so it does not provide any protection. HTTPS is a secure, encrypted alternative to HTTP, but it is used only to protect web traffic. It would protect any web communications from the remote users but would not protect other applications.<br><br>Virtual private networks (VPNs) create secure network connections between two locations and would be an effective means of protecting the communications of these remote users.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      70
    ],
    "source": "9781394454907"
  },
  {
    "id": 136,
    "question": "An organization classifies its data into four categories: Public, Internal, Sensitive, and Highly Sensitive. Which of the following data would likely be classified as Highly Sensitive?",
    "choice_a": "Press releases about new products",
    "choice_b": "Internal policy documents",
    "choice_c": "Customer credit card information",
    "choice_d": "Employee cafeteria menu",
    "correct_answer": "C",
    "explanation": "In this question, you need to identify which type of data would most likely be classified as Highly Sensitive. Press releases are public information and would fall under the Public category. Internal policy documents are typically Internal or Sensitive, depending on the content. Employee cafeteria menus are also typically classified as Public or Internal.<br><br>The only option that would likely be classified as Highly Sensitive is customer credit card information, given its nature and the significant impact its disclosure could have on customers and the organization.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      76,
      75,
      70,
      73,
      74
    ],
    "source": "9781394454907"
  },
  {
    "id": 137,
    "question": "You’re a security officer at a corporation that has a strict data retention policy. One of the company’s servers has reached end of life and is being decommissioned. Which of the following actions is the most secure method to ensure that sensitive data on the server’s magnetic hard drives (HDDs) is securely sanitized if you would like to potentially reuse the drives?",
    "choice_a": "Overwriting the data",
    "choice_b": "Formatting the drives",
    "choice_c": "Degaussing the drives",
    "choice_d": "Physically destroying the drives",
    "correct_answer": "A",
    "explanation": "This question asks for the most secure method to ensure data destruction while still allowing drive reuse.<br><br>Physically destroying the drives is the most secure method of data destruction, but it eliminates the possibility of reusing the drives, which disqualifies it as a viable answer.<br><br>Formatting the drives does not necessarily erase all data and may leave remnants that can be recovered.<br><br>Degaussing is a process that demagnetizes magnetic hard drives and can be quite effective, but it also renders them unusable for future use. Note that degaussing is only effective on magnetic media and does not work on solid-state drives (SSDs), hybrid drives, or flash storage.<br><br>Overwriting data is one of the most secure methods of data destruction that still allows for hard drive reuse. It ensures that the previous data is replaced with new data, making it difficult to recover the original data.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      74,
      88,
      73
    ],
    "source": "9781394454907"
  },
  {
    "id": 138,
    "question": "You’ve just been assigned to improve the existing log management system in your organization. Which solution would best aid in centralizing, protecting, and analyzing your log entries?",
    "choice_a": "DBMS",
    "choice_b": "NIDS",
    "choice_c": "SIEM",
    "choice_d": "IAM",
    "correct_answer": "C",
    "explanation": "A database management system (DBMS) is used primarily to manage databases and is not specifically designed for centralized log management. An identity and access management (IAM) system is more focused on managing user identities and controlling their access to resources.<br><br>While a network intrusion detection system (NIDS) does analyze network traffic and create logs of suspicious activity, it doesn’t have the capability to centralize and manage logs from various sources.<br><br>The security information and event management (SIEM) system, however, does exactly what the question requires. It provides centralized logging capabilities, securely stores logs, and employs advanced analytics to scrutinize log data for potential security incidents. So, the most suitable solution to improve the log management system in this scenario would be a SIEM system.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      78,
      100,
      87,
      91,
      79
    ],
    "source": "9781394454907"
  },
  {
    "id": 139,
    "question": "As a network security analyst, you are tasked with investigating an unusual surge in network traffic. You are looking for a way to connect the dots between different events and identify any potential security threats. Which attribute of effective logging is most useful for this task?",
    "choice_a": "Accountability",
    "choice_b": "Auditability",
    "choice_c": "Availability",
    "choice_d": "Traceability",
    "correct_answer": "D",
    "explanation": "When you face an unusual event or a security incident, the ability to identify and track all related events is crucial. This process is known as traceability. It helps analysts connect the dots between various events and provides a comprehensive view of an incident.<br><br>Accountability, or identity attribution, while important, is more about determining the origin or cause of an event, which isn’t the primary need in this scenario.<br><br>Auditability refers to documenting events, which is valuable but not the main requirement in this situation.<br><br>Availability is more closely related to the accessibility and uptime of systems and data, rather than to the investigation of security incidents.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      77,
      78,
      87,
      83,
      82
    ],
    "source": "9781394454907"
  },
  {
    "id": 140,
    "question": "Jason is monitoring his organization’s SIEM system watching for signs of unusual activity. Which phase of the NIST incident response process best describes his work?",
    "choice_a": "Preparation",
    "choice_b": "Detection & analysis",
    "choice_c": "Post-incident activity",
    "choice_d": "Containment, eradication & recovery",
    "correct_answer": "B",
    "explanation": "Jason is monitoring his environment for signs of unusual activity. This is an activity designed to identify security incidents and, therefore, belongs to the detection & analysis phase of the incident response process.<br><br>The preparation phase includes the activities used to put together an incident response program and team.<br><br>The containment, eradication, and recovery phase limits the damage caused by an incident, removes the effects of the incident, and restores normal operations.<br><br>The post-incident activity phase analyzes the response process and identifies lessons learned to improve future response efforts.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      87,
      83,
      78,
      79,
      100
    ],
    "source": "9781394454907"
  },
  {
    "id": 141,
    "question": "During his monitoring work, Jason identifies a high-priority security incident in progress. What should be his first priority?",
    "choice_a": "Identifying lessons learned",
    "choice_b": "Notifying senior management",
    "choice_c": "Recovering normal operations",
    "choice_d": "Containing the damage",
    "correct_answer": "D",
    "explanation": "This is a tricky question because Jason and the incident response team will likely take all of these actions during the incident response effort. The key to answering this question correctly is to notice that it is asking for the first priority.<br><br>The first priority of any incident response effort should always be to contain the damage. Jason should immediately take steps to isolate any affected systems to stop the spread of the incident.<br><br>Notifying senior management and activating the incident response process is also a high priority, but Jason should first take immediate action to contain the damage. If other team members are available, he can ask them to perform notification and escalation while he is containing the damage.<br><br>Recovering normal operations and identifying lessons learned come much later in the process, after the initial emergency has been resolved.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      87,
      83,
      86,
      79,
      84
    ],
    "source": "9781394454907"
  },
  {
    "id": 142,
    "question": "What is the primary risk of running end-of-life (EOL) software in a production environment?",
    "choice_a": "The software will run more slowly than newer versions.",
    "choice_b": "Newly discovered vulnerabilities will not be patched by the manufacturer.",
    "choice_c": "The software will automatically stop functioning on the EOL date.",
    "choice_d": "Users will not be able to save files created with the software.",
    "correct_answer": "B",
    "explanation": "The primary risk of running EOL software is that newly discovered vulnerabilities will not be patched by the manufacturer, leaving the organization permanently exposed to those threats.<br><br>EOL software does not automatically stop working, nor does it necessarily run slower. There should be no impact on the ability of users to save files.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      88,
      89,
      90
    ],
    "source": "9781394454907"
  },
  {
    "id": 143,
    "question": "Your organization is implementing a change management policy. Which of the following is an essential element that should be developed before implementing any change?",
    "choice_a": "A marketing plan for the change",
    "choice_b": "A rollback plan to restore the previous configuration",
    "choice_c": "A new budget for the IT department",
    "choice_d": "A press release announcing the change",
    "correct_answer": "B",
    "explanation": "A rollback plan is essential for change management because it enables restoring the previous configuration if the change causes unexpected problems.<br><br>Marketing plans, budgets, and press releases are not standard elements of the change management process.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      90,
      89
    ],
    "source": "9781394454907"
  },
  {
    "id": 144,
    "question": "Which team in a security readiness exercise simulates the actions of a real-world attacker?",
    "choice_a": "Blue team",
    "choice_b": "Purple team",
    "choice_c": "Red team",
    "choice_d": "Green team",
    "correct_answer": "C",
    "explanation": "The red team simulates the actions of a real-world attacker to test the organization’s defenses. The blue team defends. The purple team combines both approaches. There is no standard “green team” in security readiness testing.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      91,
      85,
      84
    ],
    "source": "9781394454907"
  },
  {
    "id": 145,
    "question": "An unauthorized person follows an employee through a badge-controlled door without scanning their own badge. What type of attack is this?",
    "choice_a": "Phishing",
    "choice_b": "Impersonation",
    "choice_c": "Tailgating",
    "choice_d": "Vishing",
    "correct_answer": "C",
    "explanation": "Tailgating (also called piggybacking) occurs when an unauthorized person follows an authorized person through a secured entrance without using their own credentials. Phishing uses deceptive messages, impersonation involves pretending to be someone else, and vishing is voice phishing.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      93
    ],
    "source": "9781394454907"
  },
  {
    "id": 146,
    "question": "Ravi is concerned that an adversary may have tampered with the data used to train his organization’s fraud detection model. Which type of AI-specific attack is Ravi most concerned about?",
    "choice_a": "Model drift",
    "choice_b": "Data leakage",
    "choice_c": "Model poisoning",
    "choice_d": "Impossible travel",
    "correct_answer": "C",
    "explanation": "Ravi is concerned about model poisoning. In a model poisoning attack, an adversary tampers with the training data used by a machine learning model, causing it to produce inaccurate or dangerous results.<br><br>Model drift is a gradual decline in model performance over time as real-world conditions change. It is not caused by an adversary tampering with training data.<br><br>Data leakage occurs when sensitive information is inadvertently shared with unauthorized parties, such as through the use of public AI tools. This is not related to the integrity of training data.<br><br>Impossible travel is an authentication anomaly where a user appears to log in from two distant locations in an unrealistically short time. It is an access control concept, not an attack on AI training data.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      100,
      82,
      73,
      70,
      75
    ],
    "source": "9781394454907"
  },
  {
    "id": 147,
    "question": "Keiko’s organization recently deployed a machine learning model to assist with network threat detection. She wants to ensure that the model’s service account follows security best practices. Which principle should she apply to the model’s account permissions?",
    "choice_a": "Defense in depth",
    "choice_b": "Separation of duties",
    "choice_c": "Least privilege",
    "choice_d": "Due diligence",
    "correct_answer": "C",
    "explanation": "Keiko should apply the principle of least privilege to the model’s service account. This means granting the account only the minimum permissions necessary to perform its designated tasks. Just as human users should, AI bots and automated service accounts should operate with the fewest possible privileges.<br><br>Defense in depth involves layering multiple security controls to protect against threats. While important, it does not specifically address account permissions for an AI service account.<br><br>Separation of duties ensures that no single individual can complete a critical task alone. This is an organizational control that does not directly apply to configuring permissions for an AI service account.<br><br>Due diligence involves conducting thorough research and investigation before making decisions. While relevant to AI deployment broadly, this principle does not govern account permissions.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      98,
      49,
      46,
      47
    ],
    "source": "9781394454907"
  }
];
